import { BreakpointObserver, MediaMatcher } from '@angular/cdk/layout';
import { CommonModule, DatePipe } from '@angular/common';
import { AfterViewInit } from '@angular/core';
import { ChangeDetectorRef } from '@angular/core';
import { Component } from '@angular/core';
import { FormControl, FormControlName, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioChange, MatRadioModule } from '@angular/material/radio';
import { MatTabsModule } from '@angular/material/tabs';
import { TablerIconsModule } from 'angular-tabler-icons';
import { Editor, NgxEditorComponent, NgxEditorMenuComponent, Toolbar } from 'ngx-editor';
import { MaterialModule } from '../../../material.module';
import { DateAdapter, MAT_DATE_FORMATS, MAT_NATIVE_DATE_FORMATS, provideNativeDateAdapter } from '@angular/material/core';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { NotesApiService } from '../notes/services/notes-api.service';
import { BaseSearchModel } from '../../../Data/Models/Common/base-search-model';
import { CharitiesService } from '../charities/services/charities.service';
import { AuditorsReportService } from './services/auditors-report.service';
import { TextMaskDateDirective } from '../../../Directives/text-mask-date-directive.directive';
import { Router } from '@angular/router';
import { CustomDateAdapter } from '../../../Shared/common/ng-date-parse-adapter';
import moment from 'moment';
import Swal from 'sweetalert2';
import { NotesDatashareService } from '../notes/services/notes-datashare.service';
import { CharityDataShareServiceService } from '../charities/services/charity-data-share-service.service';
import { MatSelectChange } from '@angular/material/select';
import { UsermanagementService } from '../../../services/apps/usermanagement/usermanagement.service';
import { RolesModel } from '../../../Data/Models/Users/roles-model';
import { MessageServiceService } from '../../../Shared/common/message-service.service';
import {
  MatDialog, MatDialogRef,
  MatDialogActions,
  MatDialogClose,
  MatDialogTitle,
  MatDialogContent,
  MatDialogModule,
} from '@angular/material/dialog';
import { ValidateOnTouchDirective } from '../../../Directives/validate-on-touch.directive';
import { InputRestrictionDirective } from '../../../Directives/input-restriction.directive';
import { TrimDirective } from '../../../Directives/trim.directive';
import { AllowedCharsDirective } from '../../../Directives/specialchar.directive';
import { AutoupperCaseDirective } from '../../../Directives/autoupper-case.directive';
import { MatTooltip } from '@angular/material/tooltip';
import { AbstractControl, ValidationErrors } from '@angular/forms';

export function htmlMaxLength(max: number) {
  return (control: AbstractControl): ValidationErrors | null => {
    const html = control.value || '';

    const div = document.createElement('div');
    div.innerHTML = html;

    const text = div.textContent || div.innerText || '';

    return text.length > max
      ? {
        maxlength: {
          requiredLength: max,
          actualLength: text.length
        }
      }
      : null;
  };
}

@Component({
  selector: 'app-auditor-report',
  imports: [MaterialModule, TextMaskDateDirective, MatTooltip, MatCardModule, MatRadioModule, FormsModule, ValidateOnTouchDirective, InputRestrictionDirective, NgScrollbarModule, MatFormFieldModule, MatInputModule, CommonModule, MatTabsModule, NgxEditorComponent, NgxEditorMenuComponent, TrimDirective, TablerIconsModule, MatDatepickerModule, ReactiveFormsModule, MatDialogActions, MatDialogClose, AllowedCharsDirective, MatDialogTitle, MatDialogContent, MatDialogModule, AutoupperCaseDirective],
  templateUrl: './auditor-report.component.html',
  styleUrl: './auditor-report.component.scss',
  standalone: true,
  providers: [{ provide: DateAdapter, useClass: CustomDateAdapter },
  { provide: MAT_DATE_FORMATS, useValue: MAT_NATIVE_DATE_FORMATS }, DatePipe],
})
export class AuditorReportComponent {

  isActive = 1


  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  private isInitializing = true;

  activeTabOne: boolean = true;
  editorHasError: boolean = false;
  activeTabTwo: boolean = false; activeTabThree: boolean = false; activeTabFour: boolean = false; activeTabFive: boolean = false; activeTabSix: boolean = false;
  activeTabSeven: boolean = false; activeTabEight: boolean = false; activeTabNine: boolean = false; activeTabTen: boolean = false; activeTabEleven: boolean = false; ProfessionalAdvisorsDetails_count: any = 0;
  ProfessionalAdvisorsDetails: any = [];
  activeTabIndex: number = 2;
  AuditorForm: FormGroup;
  filteredAdvisors: any = [];
  private isInitialLoad = true;
  apFinalised: boolean = false
  Previoustab: number = 0;
  addAdvisorbtn: boolean = true;
  updateAdvisorbtn: boolean = false;
  edithead: boolean = false;
  ShowSpinner: boolean = false;

  ProfessionalAdvisorsCommonForm: FormGroup;
  selectedAuditorId: any;
  private pasteHandler!: (event: ClipboardEvent) => void;

  public isCompaniesAct(): boolean {
    return (this.audited_Type || '').toLowerCase() === 'companiesact2006';
  }

  BasicInformation: any = [];
  account_Type: any;
  audited_Type: any;
  SubmissionStatus: any;

  constructor(private datePipe: DatePipe, changeDetectorRef: ChangeDetectorRef, media: MediaMatcher, private router: Router, private breakpointObserver: BreakpointObserver, private Auditors_report: AuditorsReportService, private Charity_Service: CharitiesService, private datashare: NotesDatashareService, private dataShareService: CharityDataShareServiceService, private _UsermanagementService: UsermanagementService, private msgService: MessageServiceService, private sharedService: CharityDataShareServiceService, public dialog: MatDialog, public Charities_Service: CharitiesService,
  ) {
    this.GetAllCountries();
    this.createAuditor()
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    this.GetUserAccess();
    this.orginalStatment()


  }

  lotsOfTabs = new Array(30).fill(0).map((_, index) => 'Tab {index}');

  editor: Editor;
  editor1: Editor;
  editorDescription: Editor;

  beforeYear: boolean = true;
  ngOnInit(): void {
    debugger

    this.editor = new Editor();
    this.editor1 = new Editor();
    this.editorDescription = new Editor();
    this.enablePlainTextPaste();
    this.dataShareService.finalStatus$.subscribe((value: any) => {
      this.apFinalised = value != '' && value == 'Completed'
      if (this.apFinalised || this.AuditorForm.get('approvedbyAuditor')?.value) {
        //  this.AuditorForm.get('approvedbyAuditor')?.disable();
      } else {
        this.AuditorForm.get('approvedbyAuditor')?.enable();
      }
    })

    //this.AuditorForm.get('approvedbyAuditor')?.valueChanges.subscribe(() => {
    //  this.handleApprovedByAuditorState();
    //});

    this.SubmissionStatus = localStorage.getItem('SubmissionStatus');
    //this.dataShareService.updateAccountReportType('Auditor');
    //this.GetAuditorsReport()
    this.Getbasicinformation()
    //this.tabOne();
    this.applyMaxLengthToAllControls();
    //this.GetProfessionalAdvisorsDetails();
    //this.datashare.isdirty$.subscribe(value => {
    //  this.isdirty = value
    //})
    //this.isdirty = false
    //this.datashare.setisdirty(false)
    this.isInitializing = false;
    this.noteFields.forEach(field => {
      const control = this.AuditorForm.get(field);
      //console.log(`${field}: dirty=${control?.dirty}, pristine=${control?.pristine} , valid=${control?.valid}`);
    });
    this.CreateProfessionalAdvisorsCommonForm()
    this.AuditorForm.get('approvedbyAuditor')?.valueChanges.subscribe(() => {
      this.updateIndividualDescriptionValidation();
    });
  }
  adviserTypes = ['Auditor']
  UserRoleAccess: RolesModel;
  GetUserAccess() {
    this.ShowSpinner = true;
    this._UsermanagementService.GetUserRoleAccess(localStorage['userID']).subscribe(data => {
      if (data.entity.length) {
        this.ShowSpinner = false;
        this.UserRoleAccess = data.entity[0]
        var submitedDate = this.UserRoleAccess.currentAPSubmitDate
      }
      //  this.dataShareService.finalStatus$.subscribe((value: any) => {
      //    this.apFinalised = value != '' && value == 'Completed'
      //    this.handleApprovedByAuditorState();
      //  })
    });
  }
  applyMaxLengthToAllControls() {
    const controlsToTrim = [
      'opinion',
      'basisofOpinion',
      'conclusions',
      'otherInformation',
      'othermattersprescribed',
      'reportbyexception',
      'responsibilitiesoftrustees',
      'auditorresponsibilities',
      'useofthisreport',
      'individual_Description'
    ];
    controlsToTrim.forEach(control => this.applyMaxLengthTrim(control));
  }
  AllCountriesList: any = [];
  GetAllCountries() {

    this.Charities_Service.GetCountries().subscribe((data: any) => {

      this.AllCountriesList = data
    })
  }
  onDropdownOpened(event: KeyboardEvent) {
    debugger
    let key = event.key
    if (key === 'ArrowDown' && (this.ProfessionalAdvisorsCommonForm.get('country')?.value === '' || this.ProfessionalAdvisorsCommonForm.get('country')?.value === null)) {
      // Temporarily set to first country to shift focus
      const firstCountry = this.AllCountriesList[0]?.countryID;
      this.ProfessionalAdvisorsCommonForm.get('country')?.setValue(firstCountry, { emitEvent: false });
    }
  }

  applyMaxLengthTrim(controlName: string) {
    const control = this.AuditorForm.get(controlName);
    if (!control) return;
    control.valueChanges.subscribe(value => {
      const maxLength = controlName === 'auditorresponsibilities' ? 4000 : 2500;
      if(typeof value === 'object' && value !== null) {
      const text = this.extractText(value);

      if (text.length > maxLength) {
      control.setValue(text.substring(0, maxLength), {emitEvent: false});
      }
      return;
      }
      const html = value || '';
      const trimmedHtml = this.limitHtmlContent(html, maxLength);

      if (trimmedHtml !== html) {
        control.setValue(trimmedHtml, { emitEvent: false });
      }
    });
  }
  extractText(value: any): string {
    let result = '';
    if (!value) return result;
    if (value.text) {
      result += value.text;
    }
    if (value.content && Array.isArray(value.content)) {
      value.content.forEach((child: any) => {
        result += this.extractText(child);
      });
    }

    return result;
  }


  limitHtmlContent(html: string, maxLength: number = 2500): string {
    const div = document.createElement('div');
    div.innerHTML = html;

    let charCount = 0;
    const walker = document.createTreeWalker(div, NodeFilter.SHOW_TEXT, null);
    const nodesToRemove: Node[] = [];

    while (walker.nextNode()) {
      const node = walker.currentNode as Text;
      const remaining = maxLength - charCount;

      if (remaining <= 0) {
        nodesToRemove.push(node);
      } else if (node.nodeValue!.length > remaining) {
        node.nodeValue = node.nodeValue!.substring(0, remaining);
        charCount = maxLength;
      } else {
        charCount += node.nodeValue!.length;
      }
    }

    // Remove extra text nodes
    nodesToRemove.forEach(node => node.parentNode?.removeChild(node));

    // Remove empty elements left behind
    const cleanEmptyElements = (element: HTMLElement) => {
      Array.from(element.children).forEach(child => {
        cleanEmptyElements(child as HTMLElement);
        if (
          child.childNodes.length === 0 ||
          (child.childNodes.length === 1 && child.childNodes[0].nodeType === Node.TEXT_NODE && !(child.textContent || '').trim())
        ) {
          child.remove();
        }
      });
    };

    cleanEmptyElements(div);

    return div.innerHTML;
  }
  ngOnDestroy(): void {
    this.editor.destroy();
    if (this.pasteHandler) {
      document.removeEventListener('paste', this.pasteHandler, true);
    }
    this.editor1?.destroy();
    this.editorDescription?.destroy();
  }
  onAuditorChange(data: any) { }
  toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    //['link', 'image'],
    ['text_color', 'background_color'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
  ];
  Resetform(previoustab: number) {
    if (previoustab == 1) {
      //this.AuditorForm.get('opinion')?.reset(this.defaultStatements['opinion']);
      this.ischecked = false
      this.DefaultStatement('opinion')
    }
    else if (previoustab == 2)
      this.AuditorForm.get('basisofOpinion')?.reset(this.defaultStatements['basisofOpinion']);
    else if (previoustab == 3)
      this.AuditorForm.get('conclusions')?.reset(this.defaultStatements['conclusions']);
    else if (previoustab == 4)
      this.AuditorForm.get('otherInformation')?.reset(this.defaultStatements['otherInformation']);
    else if (previoustab == 5)
      this.AuditorForm.get('othermattersprescribed')?.reset(this.defaultStatements['othermattersprescribed']);
    else if (previoustab == 6)
      this.AuditorForm.get('reportbyexception')?.reset(this.defaultStatements['reportbyexception']);
    else if (previoustab == 7)
      this.AuditorForm.get('responsibilitiesoftrustees')?.reset(this.defaultStatements['responsibilitiesoftrustees']);
    else if (previoustab == 8)
      this.AuditorForm.get('auditorresponsibilities')?.reset(this.defaultStatements['auditorresponsibilities']);
    else if (previoustab == 9)
      this.AuditorForm.get('useofthisreport')?.reset(this.defaultStatements['useofthisreport']);
    else if (previoustab == 10)
      this.AuditorForm.get('dateofAudit')?.reset
    this.AuditorForm.get('approvedbyAuditor')?.reset
    //this.handleApprovedByAuditorState();
    this.AuditorForm.get('dateCharityAuditorsReportOnRevisedAccounts')?.reset
    this.AuditorForm.get('individual_Description')?.reset



  }
  tabTwo1() {
    debugger
    if (this.hasUnsavedNoteChanges()) {
      // Show confirmation dialog or toast
      return Swal.fire({
        html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Leave the page?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Are you sure you want to leave this page. <br> Data entered will not be saved.</p>',
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Leave",
        showCancelButton: true,
        cancelButtonText: "Stay",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {

        if (result.isConfirmed) {
          this.Previoustab = this.isActive
          this.Resetform(this.Previoustab);
          this.activeTabOne = false;
          this.activeTabTwo = true;
          this.activeTabThree = false;
          this.activeTabFour = false;
          this.activeTabFive = false;
          this.activeTabSix = false;
          this.activeTabSeven = false;
          this.activeTabEight = false;
          this.activeTabNine = false;
          this.activeTabTen = false;
          this.activeTabEleven = false;
          this.isdirty = false
          this.datashare.setisdirty(false)
          this.activeTabIndex = 3
          this.noteFields.forEach(field => {
            this.AuditorForm.get(field)?.markAsPristine();
          });
          this.isActive = 2
          return true
        }
        else {
          return false
        }
      })
    }
    else {
    this.activeTabOne = false;
    this.activeTabTwo = true;
    this.activeTabThree = false;
    this.activeTabFour = false;
    this.activeTabFive = false;
    this.activeTabSix = false;
    this.activeTabSeven = false;
    this.activeTabEight = false;
    this.activeTabNine = false;
    this.activeTabTen = false;
    this.activeTabEleven = false;
    this.activeTabIndex = 3
    this.isActive = 2
     }
    return true
  }
  tabThree1() {

    if (this.hasUnsavedNoteChanges()) {
      // Show confirmation dialog or toast
      return Swal.fire({
        html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Leave the page?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Are you sure you want to leave this page. <br> Data entered will not be saved.</p>',
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Leave",
        showCancelButton: true,
        cancelButtonText: "Stay",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.Previoustab = this.isActive
          this.Resetform(this.Previoustab);
          this.activeTabOne = false;
          this.activeTabTwo = false;
          this.activeTabThree = true;
          this.activeTabFour = false;
          this.activeTabFive = false;
          this.activeTabSix = false;
          this.activeTabSeven = false;
          this.activeTabEight = false;
          this.activeTabNine = false;
          this.activeTabTen = false;
          this.activeTabEleven = false;
          this.isdirty = false
          this.datashare.setisdirty(false)
          this.activeTabIndex = 4
          this.noteFields.forEach(field => {
            this.AuditorForm.get(field)?.markAsPristine();
          });
          this.isActive = 3
          return true
        }
        else {
          return false
        }
      })
    }
    else {
    this.activeTabOne = false;
    this.activeTabTwo = false;
    this.activeTabThree = true;
    this.activeTabFour = false;
    this.activeTabFive = false;
    this.activeTabSix = false;
    this.activeTabSeven = false;
    this.activeTabEight = false;
    this.activeTabNine = false;
    this.activeTabTen = false;
    this.activeTabEleven = false;
    this.activeTabIndex = 4
    this.isActive = 3
     }
    return true
  }
  tabFour1() {

    if (this.hasUnsavedNoteChanges()) {
      // Show confirmation dialog or toast
      return Swal.fire({
        html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Leave the page?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Are you sure you want to leave this page. <br> Data entered will not be saved.</p>',
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Leave",
        showCancelButton: true,
        cancelButtonText: "Stay",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {

        if (result.isConfirmed) {
          this.Previoustab = this.isActive
          this.Resetform(this.Previoustab);
          this.activeTabOne = false;
          this.activeTabTwo = false;
          this.activeTabThree = false;
          this.activeTabFour = true;
          this.activeTabFive = false;
          this.activeTabSix = false;
          this.activeTabSeven = false;
          this.activeTabEight = false;
          this.activeTabNine = false;
          this.isdirty = false
          this.datashare.setisdirty(false)
          this.activeTabTen = false;
          this.activeTabEleven = false;
          this.activeTabIndex = 5
          this.noteFields.forEach(field => {
            this.AuditorForm.get(field)?.markAsPristine();
          });
          this.isActive = 4
          return true
        }
        else {
          return false
        }
      })
    } else {
    this.activeTabOne = false;
    this.activeTabTwo = false;
    this.activeTabThree = false;
    this.activeTabFour = true;
    this.activeTabFive = false;
    this.activeTabSix = false;
    this.activeTabSeven = false;
    this.activeTabEight = false;
    this.activeTabNine = false;
    this.activeTabTen = false;
    this.activeTabEleven = false;
    this.activeTabIndex = 5
    this.isActive = 4
     }
    return true
  }
  tabFive1() {

    if (!this.isCompaniesAct) {
      return;
    }

    debugger
    if (this.hasUnsavedNoteChanges()) {

      return Swal.fire({
        html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Leave the page?</h5> <p class="f-s-14 p-0 m-y-5 f-w-400 text-black" style="line-height:22px"> Are you sure you want to leave this page. <br> Data entered will not be saved.</p>',
          iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Leave",
        showCancelButton: true,
        cancelButtonText: "Stay",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {

        if (this.audited_Type !== 'companiesact2006') {
          return;
        }
        if (result.isConfirmed) {
          this.Previoustab = this.isActive
          this.Resetform(this.Previoustab);
          this.activeTabOne = false;
          this.activeTabTwo = false;
          this.activeTabThree = false;
          this.activeTabFour = false;
          this.activeTabFive = true;
          this.activeTabSix = false;
          this.activeTabSeven = false;
          this.activeTabEight = false;
          this.activeTabNine = false;
          this.activeTabTen = false;
          this.activeTabEleven = false;
          this.isdirty = false
          this.datashare.setisdirty(false)
          this.activeTabIndex = 6
          this.noteFields.forEach(field => {
            this.AuditorForm.get(field)?.markAsPristine();
          });
          this.isActive = 5
          return true
        }
        else {
          return false
        }
      })
    } else {
    this.activeTabOne = false;
    this.activeTabTwo = false;
    this.activeTabThree = false;
    this.activeTabFour = false;
    this.activeTabFive = true;
    this.activeTabSix = false;
    this.activeTabSeven = false;
    this.activeTabEight = false;
    this.activeTabNine = false;
    this.activeTabTen = false;
    this.activeTabEleven = false;
    this.activeTabIndex = 6
    this.isActive = 5
    return true
     }
  }

  tabSix1() {

    if (this.hasUnsavedNoteChanges()) {
      // Show confirmation dialog or toast
      return Swal.fire({
        html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Leave the page?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Are you sure you want to leave this page. <br> Data entered will not be saved.</p>',
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Leave",
        showCancelButton: true,
        cancelButtonText: "Stay",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.Previoustab = this.isActive
          this.Resetform(this.Previoustab);
          this.activeTabOne = false;
          this.activeTabTwo = false;
          this.activeTabThree = false;
          this.activeTabFour = false;
          this.activeTabFive = false;
          this.activeTabSix = true;
          this.activeTabSeven = false;
          this.activeTabEight = false;
          this.activeTabNine = false;
          this.isdirty = false
          this.datashare.setisdirty(false)
          this.activeTabTen = false;
          this.activeTabEleven = false;
          this.activeTabIndex = 7
          this.noteFields.forEach(field => {
            this.AuditorForm.get(field)?.markAsPristine();
          });
          this.isActive = 6
          return true
        }
        else {
          return false
        }
      })
    }
    else {
    this.activeTabOne = false;
    this.activeTabTwo = false;
    this.activeTabThree = false;
    this.activeTabFour = false;
    this.activeTabFive = false;
    this.activeTabSix = true;
    this.activeTabSeven = false;
    this.activeTabEight = false;
    this.activeTabNine = false;
    this.activeTabTen = false;
    this.activeTabEleven = false;
    this.activeTabIndex = 7
    this.isActive = 6
      }
    return true

  }
  tabSeven1() {

    if (this.hasUnsavedNoteChanges()) {
      // Show confirmation dialog or toast
      return Swal.fire({
        html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Leave the page?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Are you sure you want to leave this page. <br> Data entered will not be saved.</p>',
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Leave",
        showCancelButton: true,
        cancelButtonText: "Stay",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.Previoustab = this.isActive
          this.Resetform(this.Previoustab);
          this.activeTabOne = false;
          this.activeTabTwo = false;
          this.activeTabThree = false;
          this.activeTabFour = false;
          this.activeTabFive = false;
          this.activeTabSix = false;
          this.activeTabSeven = true;
          this.activeTabEight = false;
          this.isdirty = false
          this.datashare.setisdirty(false)
          this.activeTabNine = false;
          this.activeTabTen = false;
          this.activeTabEleven = false;
          this.activeTabIndex = 8
          this.noteFields.forEach(field => {
            this.AuditorForm.get(field)?.markAsPristine();
          });
          this.isActive = 7
          return true
        }
        else {
          return false
        }
      })
    }
    else {
    this.activeTabOne = false;
    this.activeTabTwo = false;
    this.activeTabThree = false;
    this.activeTabFour = false;
    this.activeTabFive = false;
    this.activeTabSix = false;
    this.activeTabSeven = true;
    this.activeTabEight = false;
    this.activeTabNine = false;
    this.activeTabTen = false;
    this.activeTabEleven = false;
    this.activeTabIndex = 8
    this.isActive = 7
     }
    return true

  }
  tabEight1() {

    if (this.hasUnsavedNoteChanges()) {
      // Show confirmation dialog or toast
      return Swal.fire({
        html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Leave the page?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Are you sure you want to leave this page. <br> Data entered will not be saved.</p>',
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Leave",
        showCancelButton: true,
        cancelButtonText: "Stay",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.Previoustab = this.isActive
          this.Resetform(this.Previoustab);
          this.activeTabOne = false;
          this.activeTabTwo = false;
          this.activeTabThree = false;
          this.activeTabFour = false;
          this.activeTabFive = false;
          this.activeTabSix = false;
          this.isdirty = false
          this.datashare.setisdirty(false)
          this.activeTabSeven = false;
          this.activeTabEight = true;
          this.activeTabNine = false;
          this.activeTabTen = false;
          this.activeTabEleven = false;
          this.activeTabIndex = 9
          this.noteFields.forEach(field => {
            this.AuditorForm.get(field)?.markAsPristine();
          });
          this.isActive = 8
          return true
        }
        else {
          return false
        }
      })
    }
    else {
    this.activeTabOne = false;
    this.activeTabTwo = false;
    this.activeTabThree = false;
    this.activeTabFour = false;
    this.activeTabFive = false;
    this.activeTabSix = false;
    this.activeTabSeven = false;
    this.activeTabEight = true;
    this.activeTabNine = false;
    this.activeTabTen = false;
    this.activeTabEleven = false;
    this.activeTabIndex = 9
    this.isActive = 8
     }
    return true

  }
  tabNine1() {

    if (this.hasUnsavedNoteChanges()) {
      // Show confirmation dialog or toast
      return Swal.fire({
        html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Leave the page?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Are you sure you want to leave this page. <br> Data entered will not be saved.</p>',
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Leave",
        showCancelButton: true,
        cancelButtonText: "Stay",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.Previoustab = this.isActive
          this.Resetform(this.Previoustab);
          this.activeTabOne = false;
          this.activeTabTwo = false;
          this.activeTabThree = false;
          this.activeTabFour = false;
          this.isdirty = false
          this.datashare.setisdirty(false)
          this.activeTabFive = false;
          this.activeTabSix = false;
          this.activeTabSeven = false;
          this.activeTabEight = false;
          this.activeTabNine = true;
          this.activeTabTen = false;
          this.activeTabEleven = false;
          this.activeTabIndex = 10
          this.noteFields.forEach(field => {
            this.AuditorForm.get(field)?.markAsPristine();
          });
          this.isActive = 9
          return true
        }
        else {
          return false
        }
      })
    }
    else {
    this.activeTabOne = false;
    this.activeTabTwo = false;
    this.activeTabThree = false;
    this.activeTabFour = false;
    this.activeTabFive = false;
    this.activeTabSix = false;
    this.activeTabSeven = false;
    this.activeTabEight = false;
    this.activeTabNine = true;
    this.activeTabTen = false;
    this.activeTabEleven = false;
    this.activeTabIndex = 10

    this.isActive = 9
    }
    return true
  }
  tabTen1() {
    debugger

    if (this.hasUnsavedNoteChanges()) {
      // Show confirmation dialog or toast
      return Swal.fire({
        html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Leave the page?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Are you sure you want to leave this page. <br> Data entered will not be saved.</p>',
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Leave",
        showCancelButton: true,
        cancelButtonText: "Stay",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.Previoustab = this.isActive
          this.Resetform(this.Previoustab);
          this.activeTabOne = false;
          this.activeTabTwo = false;
          this.activeTabThree = false;
          this.activeTabFour = false;
          this.activeTabFive = false;
          this.isdirty = false;
          this.datashare.setisdirty(false)
          this.activeTabSix = false;
          this.activeTabSeven = false;
          this.activeTabEight = false;
          this.activeTabNine = false;
          this.activeTabTen = true;
          this.activeTabEleven = false;
          this.activeTabIndex = 10
          this.isActive = 10

          this.noteFields.forEach(field => {
            this.AuditorForm.get(field)?.markAsPristine();
          });
          return true
        }
        else {
          return false
        }
      })
    }
    else {
    this.activeTabOne = false;
    this.activeTabTwo = false;
    this.activeTabThree = false;
    this.activeTabFour = false;
    this.activeTabFive = false;
    this.activeTabSix = false;
    this.activeTabSeven = false;
    this.activeTabEight = false;
    this.activeTabNine = false;
    this.activeTabTen = true;
    this.activeTabEleven = false;
    this.activeTabIndex = 11
    this.isActive = 10
     }
    return true
  }

  tabEleven1() {
    debugger
    if (this.hasUnsavedNoteChanges()) {
      // Show confirmation dialog or toast
      return Swal.fire({
        html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Leave the page?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Are you sure you want to leave this page. <br> Data entered will not be saved.</p>',
        iconHtml: '<span class="fa fa-question"></span>',
        confirmButtonText: "Leave",
        showCancelButton: true,
        cancelButtonText: "Stay",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.Previoustab = this.isActive
          this.Resetform(this.Previoustab);
          this.activeTabOne = false;
          this.activeTabTwo = false;
          this.activeTabThree = false;
          this.activeTabFour = false;
          this.activeTabFive = false;
          this.isdirty = false;
          this.datashare.setisdirty(false)
          this.activeTabSix = false;
          this.activeTabSeven = false;
          this.activeTabEight = false;
          this.activeTabNine = false;
          this.activeTabTen = false;
          this.activeTabEleven = true
          this.activeTabIndex = 12
          this.isActive = 11

          this.noteFields.forEach(field => {
            this.AuditorForm.get(field)?.markAsPristine();
          });
          return true
        }
        else {
          return false
        }
      })
    }
    else {

    this.activeTabOne = false;
    this.activeTabTwo = false;
    this.activeTabThree = false;
    this.activeTabFour = false;
    this.activeTabFive = false;
    this.activeTabSix = false;
    this.activeTabSeven = false;
    this.activeTabEight = false;
    this.activeTabNine = false;
    this.activeTabTen = false;
    this.activeTabEleven = true;
    this.activeTabIndex = 12
    this.isActive = 11
      }
    return true
  }

  tabOne() {

    if (this.hasUnsavedNoteChanges()) {
      debugger
      // Show confirmation dialog or toast
      return Swal.fire({
        html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Leave the page?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Are you sure you want to leave this page. <br> Data entered will not be saved.</p>',
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Leave",
        showCancelButton: true,
        cancelButtonText: "Stay",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.Previoustab = this.isActive
          this.Resetform(this.Previoustab);
          this.activeTabOne = true;
          this.activeTabTwo = false;
          this.activeTabThree = false;
          this.activeTabFour = false;
          this.activeTabFive = false;
          this.activeTabSix = false;
          this.activeTabSeven = false;
          this.activeTabEight = false;
          this.activeTabNine = false;
          this.activeTabTen = false;
          this.activeTabEleven = false;
          this.activeTabIndex = 2
          this.isdirty = false
          this.datashare.setisdirty(false)
          this.noteFields.forEach(field => {
            this.AuditorForm.get(field)?.markAsPristine();
          });
          this.isActive = 1
          return true
        }
        else {
          return false
        }
      })
    }
    else {
    this.activeTabOne = true;
    this.activeTabTwo = false;
    this.activeTabThree = false;
    this.activeTabFour = false;
    this.activeTabFive = false;
    this.activeTabSix = false;
    this.activeTabSeven = false;
    this.activeTabEight = false;
    this.activeTabNine = false;
    this.activeTabTen = false;
    this.activeTabEleven = false;
    this.activeTabIndex = 2
    this.isActive = 1
      }
    return true
  }
  tabTwo() {
    debugger
    //if (this.hasUnsavedNoteChanges()) {
    //  // Show confirmation dialog or toast
    //  return Swal.fire({
    //    html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Leave the page?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Are you sure you want to leave this page. <br> Data entered will not be saved.</p>',
    //    iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
    //    confirmButtonText: "Leave",
    //    showCancelButton: true,
    //    cancelButtonText: "Stay",
    //    allowOutsideClick: false,
    //    reverseButtons: true
    //  }).then((result) => {

    //    if (result.isConfirmed) {
    //      this.Previoustab = this.isActive
    //      this.Resetform(this.Previoustab);
    //      this.activeTabOne = false;
    //      this.activeTabTwo = true;
    //      this.activeTabThree = false;
    //      this.activeTabFour = false;
    //      this.activeTabFive = false;
    //      this.activeTabSix = false;
    //      this.activeTabSeven = false;
    //      this.activeTabEight = false;
    //      this.activeTabNine = false;
    //      this.activeTabTen = false;
    //      this.activeTabEleven = false;
    //      this.isdirty = false
    //      this.datashare.setisdirty(false)
    //      this.activeTabIndex = 3
    //      this.noteFields.forEach(field => {
    //        this.AuditorForm.get(field)?.markAsPristine();
    //      });
    //      this.isActive = 2
    //      return true
    //    }
    //    else {
    //      return false
    //    }
    //  })
    //}
    //else {
    this.activeTabOne = false;
    this.activeTabTwo = true;
    this.activeTabThree = false;
    this.activeTabFour = false;
    this.activeTabFive = false;
    this.activeTabSix = false;
    this.activeTabSeven = false;
    this.activeTabEight = false;
    this.activeTabNine = false;
    this.activeTabTen = false;
    this.activeTabEleven = false;
    this.activeTabIndex = 3
    this.isActive = 2
    //  }
    return true
  }
  tabThree() {

    //if (this.hasUnsavedNoteChanges()) {
    //  // Show confirmation dialog or toast
    //  return Swal.fire({
    //    html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Leave the page?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Are you sure you want to leave this page. <br> Data entered will not be saved.</p>',
    //    iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
    //    confirmButtonText: "Leave",
    //    showCancelButton: true,
    //    cancelButtonText: "Stay",
    //    allowOutsideClick: false,
    //    reverseButtons: true
    //  }).then((result) => {
    //    if (result.isConfirmed) {
    //      this.Previoustab = this.isActive
    //      this.Resetform(this.Previoustab);
    //      this.activeTabOne = false;
    //      this.activeTabTwo = false;
    //      this.activeTabThree = true;
    //      this.activeTabFour = false;
    //      this.activeTabFive = false;
    //      this.activeTabSix = false;
    //      this.activeTabSeven = false;
    //      this.activeTabEight = false;
    //      this.activeTabNine = false;
    //      this.activeTabTen = false;
    //      this.activeTabEleven = false;
    //      this.isdirty = false
    //      this.datashare.setisdirty(false)
    //      this.activeTabIndex = 4
    //      this.noteFields.forEach(field => {
    //        this.AuditorForm.get(field)?.markAsPristine();
    //      });
    //      this.isActive = 3
    //      return true
    //    }
    //    else {
    //      return false
    //    }
    //  })
    //}
    //else {
    this.activeTabOne = false;
    this.activeTabTwo = false;
    this.activeTabThree = true;
    this.activeTabFour = false;
    this.activeTabFive = false;
    this.activeTabSix = false;
    this.activeTabSeven = false;
    this.activeTabEight = false;
    this.activeTabNine = false;
    this.activeTabTen = false;
    this.activeTabEleven = false;
    this.activeTabIndex = 4
    this.isActive = 3
    //}
    return true
  }
  tabFour() {

    //if (this.hasUnsavedNoteChanges()) {
    //  // Show confirmation dialog or toast
    //  return Swal.fire({
    //    html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Leave the page?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Are you sure you want to leave this page. <br> Data entered will not be saved.</p>',
    //    iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
    //    confirmButtonText: "Leave",
    //    showCancelButton: true,
    //    cancelButtonText: "Stay",
    //    allowOutsideClick: false,
    //    reverseButtons: true
    //  }).then((result) => {

    //    if (result.isConfirmed) {
    //      this.Previoustab = this.isActive
    //      this.Resetform(this.Previoustab);
    //      this.activeTabOne = false;
    //      this.activeTabTwo = false;
    //      this.activeTabThree = false;
    //      this.activeTabFour = true;
    //      this.activeTabFive = false;
    //      this.activeTabSix = false;
    //      this.activeTabSeven = false;
    //      this.activeTabEight = false;
    //      this.activeTabNine = false;
    //      this.isdirty = false
    //      this.datashare.setisdirty(false)
    //      this.activeTabTen = false;
    //      this.activeTabEleven = false;
    //      this.activeTabIndex = 5
    //      this.noteFields.forEach(field => {
    //        this.AuditorForm.get(field)?.markAsPristine();
    //      });
    //      this.isActive = 4
    //      return true
    //    }
    //    else {
    //      return false
    //    }
    //  })
    //} else {
    this.activeTabOne = false;
    this.activeTabTwo = false;
    this.activeTabThree = false;
    this.activeTabFour = true;
    this.activeTabFive = false;
    this.activeTabSix = false;
    this.activeTabSeven = false;
    this.activeTabEight = false;
    this.activeTabNine = false;
    this.activeTabTen = false;
    this.activeTabEleven = false;
    this.activeTabIndex = 5
    this.isActive = 4
    // }
    return true
  }
  tabFive() {

    if (!this.isCompaniesAct) {
      return false;
    }

    //if (this.hasUnsavedNoteChanges()) {
    //  debugger

    //  return Swal.fire({
    //    html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Leave the page?</h5> <p class="f-s-14 p-0 m-y-5 f-w-400 text-black" style="line-height:22px"> Are you sure you want to leave this page. <br> Data entered will not be saved.</p>',
    //      iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
    //    confirmButtonText: "Leave",
    //    showCancelButton: true,
    //    cancelButtonText: "Stay",
    //    allowOutsideClick: false,
    //    reverseButtons: true
    //  }).then((result) => {
    //    if (result.isConfirmed) {
    //      this.Previoustab = this.isActive
    //      this.Resetform(this.Previoustab);
    //      this.activeTabOne = false;
    //      this.activeTabTwo = false;
    //      this.activeTabThree = false;
    //      this.activeTabFour = false;
    //      this.activeTabFive = true;
    //      this.activeTabSix = false;
    //      this.activeTabSeven = false;
    //      this.activeTabEight = false;
    //      this.activeTabNine = false;
    //      this.activeTabTen = false;
    //      this.activeTabEleven = false;
    //      this.isdirty = false
    //      this.datashare.setisdirty(false)    
    //      this.activeTabIndex = 6
    //      this.noteFields.forEach(field => {
    //        this.AuditorForm.get(field)?.markAsPristine();
    //      });
    //      this.isActive = 5
    //      return true
    //    }
    //    else {
    //      return false
    //    }
    //  })
    //} else {
    this.activeTabOne = false;
    this.activeTabTwo = false;
    this.activeTabThree = false;
    this.activeTabFour = false;
    this.activeTabFive = true;
    this.activeTabSix = false;
    this.activeTabSeven = false;
    this.activeTabEight = false;
    this.activeTabNine = false;
    this.activeTabTen = false;
    this.activeTabEleven = false;
    this.activeTabIndex = 6
    this.isActive = 5
    return true
    //}
  }

  tabSix() {

    //if (this.hasUnsavedNoteChanges()) {
    //  // Show confirmation dialog or toast
    //  return Swal.fire({
    //    html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Leave the page?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Are you sure you want to leave this page. <br> Data entered will not be saved.</p>',
    //    iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
    //    confirmButtonText: "Leave",
    //    showCancelButton: true,
    //    cancelButtonText: "Stay",
    //    allowOutsideClick: false,
    //    reverseButtons: true
    //  }).then((result) => {
    //    if (result.isConfirmed) {
    //      this.Previoustab = this.isActive
    //      this.Resetform(this.Previoustab);
    //      this.activeTabOne = false;
    //      this.activeTabTwo = false;
    //      this.activeTabThree = false;
    //      this.activeTabFour = false;
    //      this.activeTabFive = false;
    //      this.activeTabSix = true;
    //      this.activeTabSeven = false;
    //      this.activeTabEight = false;
    //      this.activeTabNine = false;
    //      this.isdirty = false
    //      this.datashare.setisdirty(false)
    //      this.activeTabTen = false;
    //      this.activeTabEleven = false;
    //      this.activeTabIndex = 7
    //      this.noteFields.forEach(field => {
    //        this.AuditorForm.get(field)?.markAsPristine();
    //      });
    //      this.isActive = 6
    //      return true
    //    }
    //    else {
    //      return false
    //    }
    //  })
    //}
    //else {
    this.activeTabOne = false;
    this.activeTabTwo = false;
    this.activeTabThree = false;
    this.activeTabFour = false;
    this.activeTabFive = false;
    this.activeTabSix = true;
    this.activeTabSeven = false;
    this.activeTabEight = false;
    this.activeTabNine = false;
    this.activeTabTen = false;
    this.activeTabEleven = false;
    this.activeTabIndex = 7
    this.isActive = 6
    //  }
    return true

  }
  tabSeven() {

    //if (this.hasUnsavedNoteChanges()) {
    //  // Show confirmation dialog or toast
    //  return Swal.fire({
    //    html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Leave the page?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Are you sure you want to leave this page. <br> Data entered will not be saved.</p>',
    //    iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
    //    confirmButtonText: "Leave",
    //    showCancelButton: true,
    //    cancelButtonText: "Stay",
    //    allowOutsideClick: false,
    //    reverseButtons: true
    //  }).then((result) => {
    //    if (result.isConfirmed) {
    //      this.Previoustab = this.isActive
    //      this.Resetform(this.Previoustab);
    //      this.activeTabOne = false;
    //      this.activeTabTwo = false;
    //      this.activeTabThree = false;
    //      this.activeTabFour = false;
    //      this.activeTabFive = false;
    //      this.activeTabSix = false;
    //      this.activeTabSeven = true;
    //      this.activeTabEight = false;
    //      this.isdirty = false
    //      this.datashare.setisdirty(false)
    //      this.activeTabNine = false;
    //      this.activeTabTen = false;
    //      this.activeTabEleven = false;
    //      this.activeTabIndex = 8
    //      this.noteFields.forEach(field => {
    //        this.AuditorForm.get(field)?.markAsPristine();
    //      });
    //      this.isActive = 7
    //      return true
    //    }
    //    else {
    //      return false
    //    }
    //  })
    //}
    //else {
    this.activeTabOne = false;
    this.activeTabTwo = false;
    this.activeTabThree = false;
    this.activeTabFour = false;
    this.activeTabFive = false;
    this.activeTabSix = false;
    this.activeTabSeven = true;
    this.activeTabEight = false;
    this.activeTabNine = false;
    this.activeTabTen = false;
    this.activeTabEleven = false;
    this.activeTabIndex = 8
    this.isActive = 7
    //}
    return true

  }
  tabEight() {

    //if (this.hasUnsavedNoteChanges()) {
    //  // Show confirmation dialog or toast
    //  return Swal.fire({
    //    html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Leave the page?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Are you sure you want to leave this page. <br> Data entered will not be saved.</p>',
    //    iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
    //    confirmButtonText: "Leave",
    //    showCancelButton: true,
    //    cancelButtonText: "Stay",
    //    allowOutsideClick: false,
    //    reverseButtons: true
    //  }).then((result) => {
    //    if (result.isConfirmed) {
    //      this.Previoustab = this.isActive
    //      this.Resetform(this.Previoustab);
    //      this.activeTabOne = false;
    //      this.activeTabTwo = false;
    //      this.activeTabThree = false;
    //      this.activeTabFour = false;
    //      this.activeTabFive = false;
    //      this.activeTabSix = false;
    //      this.isdirty = false
    //      this.datashare.setisdirty(false)
    //      this.activeTabSeven = false;
    //      this.activeTabEight = true;
    //      this.activeTabNine = false;
    //      this.activeTabTen = false;
    //      this.activeTabEleven = false;
    //      this.activeTabIndex = 9
    //      this.noteFields.forEach(field => {
    //        this.AuditorForm.get(field)?.markAsPristine();
    //      });
    //      this.isActive = 8
    //      return true
    //    }
    //    else {
    //      return false
    //    }
    //  })
    //}
    //else
    //{
    this.activeTabOne = false;
    this.activeTabTwo = false;
    this.activeTabThree = false;
    this.activeTabFour = false;
    this.activeTabFive = false;
    this.activeTabSix = false;
    this.activeTabSeven = false;
    this.activeTabEight = true;
    this.activeTabNine = false;
    this.activeTabTen = false;
    this.activeTabEleven = false;
    this.activeTabIndex = 9
    this.isActive = 8
    // }
    return true

  }
  tabNine() {

    //if (this.hasUnsavedNoteChanges()) {
    //  // Show confirmation dialog or toast
    //  return Swal.fire({
    //    html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Leave the page?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Are you sure you want to leave this page. <br> Data entered will not be saved.</p>',
    //    iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
    //    confirmButtonText: "Leave",
    //    showCancelButton: true,
    //    cancelButtonText: "Stay",
    //    allowOutsideClick: false,
    //    reverseButtons: true
    //  }).then((result) => {
    //    if (result.isConfirmed) {
    //      this.Previoustab = this.isActive
    //      this.Resetform(this.Previoustab);
    //      this.activeTabOne = false;
    //      this.activeTabTwo = false;
    //      this.activeTabThree = false;
    //      this.activeTabFour = false;
    //      this.isdirty = false
    //      this.datashare.setisdirty(false)
    //      this.activeTabFive = false;
    //      this.activeTabSix = false;
    //      this.activeTabSeven = false;
    //      this.activeTabEight = false;
    //      this.activeTabNine = true;
    //      this.activeTabTen = false;
    //      this.activeTabEleven = false;
    //      this.activeTabIndex = 10
    //      this.noteFields.forEach(field => {
    //        this.AuditorForm.get(field)?.markAsPristine();
    //      });
    //      this.isActive = 9
    //      return true
    //    }
    //    else {
    //      return false
    //    }
    //  })
    //}
    //else {
    this.activeTabOne = false;
    this.activeTabTwo = false;
    this.activeTabThree = false;
    this.activeTabFour = false;
    this.activeTabFive = false;
    this.activeTabSix = false;
    this.activeTabSeven = false;
    this.activeTabEight = false;
    this.activeTabNine = true;
    this.activeTabTen = false;
    this.activeTabEleven = false;
    this.activeTabIndex = 10
    this.isActive = 9
    //}
    return true
  }
  tabTen() {

    //if (this.hasUnsavedNoteChanges()) {
    //  // Show confirmation dialog or toast
    //  return Swal.fire({
    //    html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Leave the page?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Are you sure you want to leave this page. <br> Data entered will not be saved.</p>',
    //    iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
    //    confirmButtonText: "Leave",
    //    showCancelButton: true,
    //    cancelButtonText: "Stay",
    //    allowOutsideClick: false,
    //    reverseButtons: true
    //  }).then((result) => {
    //    if (result.isConfirmed) {
    //      this.Previoustab = this.isActive
    //      this.Resetform(this.Previoustab);
    //      this.activeTabOne = false;
    //      this.activeTabTwo = false;
    //      this.activeTabThree = false;
    //      this.activeTabFour = false;
    //      this.activeTabFive = false;
    //      this.isdirty = false;
    //      this.datashare.setisdirty(false)
    //      this.activeTabSix = false;
    //      this.activeTabSeven = false;
    //      this.activeTabEight = false;
    //      this.activeTabNine = false;
    //      this.activeTabTen = true;
    //      this.activeTabEleven = false;
    //      this.activeTabIndex = 10
    //      this.isActive = 10

    //      this.noteFields.forEach(field => {
    //        this.AuditorForm.get(field)?.markAsPristine();
    //      });
    //      return true
    //    }
    //    else {
    //      return false
    //    }
    //  })
    //}
    //else {
    this.activeTabOne = false;
    this.activeTabTwo = false;
    this.activeTabThree = false;
    this.activeTabFour = false;
    this.activeTabFive = false;
    this.activeTabSix = false;
    this.activeTabSeven = false;
    this.activeTabEight = false;
    this.activeTabNine = false;
    this.activeTabTen = true;
    this.activeTabEleven = false;
    this.activeTabIndex = 11
    this.isActive = 10
    //}
    return true
  }

  tabEleven() {

    //if (this.hasUnsavedNoteChanges()) {
    //  // Show confirmation dialog or toast
    //  return Swal.fire({
    //    html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Leave the page?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Are you sure you want to leave this page. <br> Data entered will not be saved.</p>',
    //    iconHtml: '<span class="fa fa-question"></span>',
    //    confirmButtonText: "Leave",
    //    showCancelButton: true,
    //    cancelButtonText: "Stay",
    //    allowOutsideClick: false,
    //    reverseButtons: true
    //  }).then((result) => {
    //    if (result.isConfirmed) {
    //      this.Previoustab = this.isActive
    //      this.Resetform(this.Previoustab);
    //      this.activeTabOne = false;
    //      this.activeTabTwo = false;
    //      this.activeTabThree = false;
    //      this.activeTabFour = false;
    //      this.activeTabFive = false;
    //      this.isdirty = false;
    //      this.datashare.setisdirty(false)
    //      this.activeTabSix = false;
    //      this.activeTabSeven = false;
    //      this.activeTabEight = false;
    //      this.activeTabNine = false;
    //      this.activeTabTen = false;
    //      this.activeTabEleven = true;
    //      this.activeTabIndex = 12
    //      this.isActive = 11

    //      this.noteFields.forEach(field => {
    //        this.AuditorForm.get(field)?.markAsPristine();
    //      });
    //      return true
    //    }
    //    else {
    //      return false
    //    }
    //  })
    //}
    //else {
    this.activeTabOne = false;
    this.activeTabTwo = false;
    this.activeTabThree = false;
    this.activeTabFour = false;
    this.activeTabFive = false;
    this.activeTabSix = false;
    this.activeTabSeven = false;
    this.activeTabEight = false;
    this.activeTabNine = false;
    this.activeTabTen = false;
    this.activeTabEleven = true;
    this.activeTabIndex = 12
    this.isActive = 11
    // }
    return true
  }

  disableNaviagtion() {
    document.body.classList.add('disable')
  }
  enableNavigation() {
    document.body.classList.remove('disable')
  }
  AdvisorsID: any; SaveAdviserRecord: any = [];
  GetProfessionalAdvisorsDetails() {
    debugger

    var charityid = localStorage.getItem('charityId');
    this.Charity_Service.getProfessionalAdvisorDetails(charityid).subscribe((data: any) => {
      debugger
      this.ProfessionalAdvisorsDetails = data.entity
      this.filteredAdvisors = this.ProfessionalAdvisorsDetails.filter((advisor: any) => advisor?.professionalAdvisors_Type === "Auditor");
      const primaryAuditor = this.filteredAdvisors.find((auditor: any) => auditor.isPrimary === true);
      const auditorValue = this.AuditorForm.get('professionalAdvisors_Name')?.value;
      //if (this.AuditorForm.controls['approvedbyAuditor']?.getRawValue()) {
      //  if (primaryAuditor?.advisor_audited_Type == 'Individual Charity Auditor' && !auditorValue && this.beforeYear == true) {
      //    this.AuditorForm.get('approvedbyAuditor')?.setValue(primaryAuditor.advisorsId)
      //    //  this.AuditorForm.get('approvedbyAuditor')?.disable();
      //  }
      //}
      //if (this.AuditorForm.controls['approvedbyAuditor']?.getRawValue()) {
      //  if (primaryAuditor?.advisor_audited_Type == 'Senior Statutory Charity Auditor' && !auditorValue && this.beforeYear == false) {
      //    this.AuditorForm.get('approvedbyAuditor')?.setValue(primaryAuditor.advisorsId)
      //    // this.AuditorForm.get('approvedbyAuditor')?.disable();
      //  }
      //}
      if (!this.AuditorForm.controls['approvedbyAuditor']?.getRawValue() && primaryAuditor) {
        this.AuditorForm.get('approvedbyAuditor')?.setValue(primaryAuditor.advisorsId)
      }
      if (data.entity != null) {
        this.ProfessionalAdvisorsDetails_count = this.ProfessionalAdvisorsDetails?.length
        this.filteredAdvisors = this.ProfessionalAdvisorsDetails.filter(
          (advisor: { professionalAdvisors_Type: string; }) => advisor.professionalAdvisors_Type === "Auditor"
        );
      } else {
        this.ProfessionalAdvisorsDetails_count = 0
      }

      //if (data.entity != null) {
      //  ////Save record Start
      //  //this.SaveAdviserRecord = this.ProfessionalAdvisorsDetails.filter(
      //  //  (advisor: { professionalAdvisors_Type: string; }) => advisor.professionalAdvisors_Type === "Auditor"
      //  //);
      //  //this.AdvisorsID = this.SaveAdviserRecord[0]?.advisorsId
      //  ////end
      //  if (this.beforeYear == true) {
      //    this.ProfessionalAdvisorsDetails_count = this.ProfessionalAdvisorsDetails?.length
      //    this.filteredAdvisors = this.ProfessionalAdvisorsDetails.filter(
      //      (advisor: { professionalAdvisors_Type: string; }) => advisor.professionalAdvisors_Type === "Auditor"
      //    );
      //  } else {
      //    this.ProfessionalAdvisorsDetails_count = this.ProfessionalAdvisorsDetails?.length
      //    this.filteredAdvisors = this.ProfessionalAdvisorsDetails.filter(
      //      (advisor: { professionalAdvisors_Type: string; advisor_audited_Type: string; }) => advisor.professionalAdvisors_Type === "Auditor" && advisor.advisor_audited_Type === "Senior Statutory Charity Auditor"
      //    )

      //  }
      //  //this.AuditorForm.controls['approvedbyAuditor'].setValue(this.filteredAdvisors[0]?.advisorsId);
      //  //if (this.AuditorForm.controls['approvedbyAuditor']?.value) {
      //  //  this.AuditorForm.controls['approvedbyAuditor'].disable()
      //  //}
      //  //this.handleApprovedByAuditorState();
      //  this.ShowSpinner = false;
      //  this.dialog.closeAll();
      //} else {
      //  this.ProfessionalAdvisorsDetails_count = 0
      //}
    })
  }
  updateIndividualDescriptionValidation() {

    const auditorId = this.AuditorForm.get('approvedbyAuditor')?.value;

    const selectedAuditor = this.filteredAdvisors?.find(
      (x: any) => x.advisorsId == auditorId
    );

    const control = this.AuditorForm.get('individual_Description');

    const shouldShow =
      this.audited_Type === 'companiesact2006' &&
      selectedAuditor?.advisor_audited_Type === 'Individual Charity Auditor' &&
      this.beforeYear;

    if (shouldShow) {
      control?.setValidators([Validators.required]);
    } else {
      control?.clearValidators();
      control?.setErrors(null);
    }

    control?.updateValueAndValidity();
  }
  showIndividualDescription(): boolean {

    const auditorId = this.AuditorForm.get('approvedbyAuditor')?.value;

    const selectedAuditor = this.filteredAdvisors?.find(
      (x: any) => x.advisorsId == auditorId
    );

    return (
      this.audited_Type === 'companiesact2006' &&
      selectedAuditor?.advisor_audited_Type === 'Individual Charity Auditor' &&
      this.beforeYear
    );
  }
  saveAndNext() {
    debugger
    this.updateIndividualDescriptionValidation();
    this.isdirty = false
    this.datashare.setisdirty(false)
    this.AuditorForm.markAsPristine();
    Object.keys(this.AuditorForm.controls).forEach(key => {
      this.AuditorForm.get(key)?.markAsPristine();
    });
    if (this.activeTabIndex <= 11) {
      if (this.activeTabIndex == 1) {
        // this.AuditorForm.get('opinion')?.markAsPristine();
        if (this.editorHasError == true) {
          return
        }
        else {
          this.noteFields.forEach(field => {
            this.AuditorForm.get(field)?.markAsPristine();
          });
          this.tabOne();
          this.isActive = 1
        }
      }
      else if (this.activeTabIndex == 2) {
        //this.AuditorForm.get('basisofOpinion')?.markAsPristine();
        if (this.editorHasError == true) {
          return
        } else {
          this.noteFields.forEach(field => {
            this.AuditorForm.get(field)?.markAsPristine();
          });
          this.tabTwo();
          this.isActive = 2

        }
      }
      else if (this.activeTabIndex == 3) {
        // this.AuditorForm.get('conclusions')?.markAsPristine();
        if (this.editorHasError == true) {
          return
        }
        else {
          this.noteFields.forEach(field => {
            this.AuditorForm.get(field)?.markAsPristine();
          });
          this.tabThree();
          this.isActive = 3
        }
      }
      else if (this.activeTabIndex == 4) {
        //this.AuditorForm.get('otherInformation')?.markAsPristine();
        if (this.editorHasError == true) {
          return
        } else {
          this.noteFields.forEach(field => {
            this.AuditorForm.get(field)?.markAsPristine();
          });
          this.tabFour();
          this.isActive = 4
        }
      }
      else if (this.activeTabIndex == 5) {
        if (this.editorHasError == true) {
          return;
        }
        this.noteFields.forEach(field => {
          this.AuditorForm.get(field)?.markAsPristine();
        });


        if (this.isCompaniesAct()) {
          this.tabFive();
          this.isActive = 5;
          this.activeTabIndex = 6;
        } else {
          this.tabSix();
          this.isActive = 6;
          this.activeTabIndex = 7;
        }
      }
      else if (this.activeTabIndex == 6) {
        // this.AuditorForm.get('reportbyexception')?.markAsPristine();
        if (this.editorHasError == true) {
          return
        } else {
          this.noteFields.forEach(field => {
            this.AuditorForm.get(field)?.markAsPristine();
          });
          this.tabSix();
          this.isActive = 6
        }
      }
      else if (this.activeTabIndex == 7) {
        //this.AuditorForm.get('responsibilitiesoftrustees')?.markAsPristine();
        if (this.editorHasError == true) {
          return
        } else {
          this.noteFields.forEach(field => {
            this.AuditorForm.get(field)?.markAsPristine();
          });
          this.tabSeven();
          this.isActive = 7
        }
      }
      else if (this.activeTabIndex == 8) {
        //this.AuditorForm.get('auditorresponsibilities')?.markAsPristine();
        if (this.editorHasError == true) {
          return
        } else {
          this.noteFields.forEach(field => {
            this.AuditorForm.get(field)?.markAsPristine();
          });
          this.tabEight();
          this.isActive = 8
        }
      }
      else if (this.activeTabIndex == 9) {
        //this.AuditorForm.get('useofthisreport')?.markAsPristine();
        if (this.editorHasError == true) {
          return
        } else {
          this.noteFields.forEach(field => {
            this.AuditorForm.get(field)?.markAsPristine();
          });
          this.tabNine();
          this.isActive = 9
        }
      }
      else if (this.activeTabIndex == 10) {


        this.noteFields.forEach(field => {
          this.AuditorForm.get(field)?.markAsPristine();
        });

        //if (this.account_Type === 'Amended') { 

        //  this.tabTen();
        //  this.isActive = 10;

        //} else {
        this.tabEleven();
        this.isActive = 11
        //}
      }


      else if (this.activeTabIndex == 11) {


        this.noteFields.forEach(field => {
          this.AuditorForm.get(field)?.markAsPristine();
        });

        this.tabEleven();
        this.isActive = 11



      }
    }
    else {

      const auditor = this.filteredAdvisors?.filter((x: any) => x.advisorsId == this.AuditorForm?.controls['approvedbyAuditor']?.getRawValue())
      if (auditor.length) {
        if (auditor[0]?.advisor_audited_Type == 'Individual Charity Auditor' && this.beforeYear == false) {
          Swal.fire({
            html: `<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Compliance Notice:</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px">As per the Companies Act requirements effective from 2026, the Auditor's Report must be signed by a Senior Statutory Auditor instead of an Individual Auditor.</p>`,
            iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
            confirmButtonText: "Ok",
            allowOutsideClick: false
          })
          return;
        }
      }
      if ((this.AuditorForm.controls['opinion'].value != "<p></p>" && this.AuditorForm.controls['opinion'].value != "") || (this.AuditorForm.controls['opinion'].value != "<p></p>" &&
        (
          this.AuditorForm.controls['basisofOpinion'].value != "<p></p>" ||
          (this.audited_Type == 'companiesact2006' && this.AuditorForm.controls['othermattersprescribed'].value != "<p></p>") ||
          this.AuditorForm.controls['reportbyexception'].value != "<p></p>" ||
          this.AuditorForm.controls['responsibilitiesoftrustees'].value != "<p></p>" ||
          this.AuditorForm.controls['auditorresponsibilities'].value != "<p></p>" ||
          this.AuditorForm.controls['useofthisreport'].value != "<p></p>" ||
          this.AuditorForm.controls['conclusions'].value != "<p></p>") ||
        this.AuditorForm.controls['individual_Description'].value != "<p></p>")
        &&
        (this.AuditorForm.controls['opinion'].value != "" &&
          (
            this.AuditorForm.controls['basisofOpinion'].value != "" ||
            (this.audited_Type == 'companiesact2006' && this.AuditorForm.controls['othermattersprescribed'].value != "") ||
            this.AuditorForm.controls['reportbyexception'].value != "" ||
            this.AuditorForm.controls['responsibilitiesoftrustees'].value != "" ||
            this.AuditorForm.controls['auditorresponsibilities'].value != "" ||
            this.AuditorForm.controls['useofthisreport'].value != "" ||
            this.AuditorForm.controls['individual_Description'].value != "" ||
            this.AuditorForm.controls['conclusions'].value != ""))) {

        const dateControl = this.AuditorForm.get('dateofAudit');
        const auditorControl = this.AuditorForm.get('approvedbyAuditor');
        const reviseddate = this.AuditorForm.get('dateCharityAuditorsReportOnRevisedAccounts');

        //for date validations
        const inputValue = this.AuditorForm.get('dateofAudit')?.value;
        const momentDate = moment(inputValue, 'DD/MM/YYYY', true);
        const isValidDate = momentDate.isValid();

        const acpStart = moment(this.BasicInformation[0].current_AP_Start_Date); // start date
        const acpEnd = moment(this.BasicInformation[0].current_AP_End_Date);     // end date
        const today = moment(); // current date
        const originalDate = moment(this.AuditorForm.get('dateofAudit')?.value);
        const revisedDate = moment(this.AuditorForm.get('dateCharityAuditorsReportOnRevisedAccounts')?.value)


        if (this.AuditorForm.get('dateofAudit')?.value && this.AuditorForm.get('dateCharityAuditorsReportOnRevisedAccounts')?.value) {
          if (momentDate.isAfter(today, 'day')) {
            this.AuditorForm.get('dateofAudit')?.setErrors({ IsAfterToday: true });
          } else if (momentDate.isBefore(acpStart, 'day')) {
            this.AuditorForm.get('dateofAudit')?.setErrors({ BeforeAccountingPeriod: true });
          }
          else if ((momentDate.isAfter(revisedDate, 'day')) && this.AuditorForm.get('dateCharityAuditorsReportOnRevisedAccounts')?.value) {
            this.AuditorForm.get('dateCharityAuditorsReportOnRevisedAccounts')?.setErrors({ AfterOriginalDate: true });
          }
          else {
            this.AuditorForm.get('dateofAudit')?.setErrors(null); // valid date
          }
        }
        //end
        if (dateControl?.value == null && auditorControl?.value == null && reviseddate?.value == null) {
          if (dateControl?.errors?.['InvalidDate']) {
            this.AuditorForm.get('dateofAudit')?.setErrors({ InvalidDate: true })
            this.AuditorForm.get('approvedbyAuditor')?.setErrors({ required: true });
            this.AuditorForm.get('dateofAudit')?.markAsTouched();
            if (this.account_Type == 'Amended') {
              this.AuditorForm.get('dateCharityAuditorsReportOnRevisedAccounts')?.setErrors({ InvalidDate: true })
              this.AuditorForm.get('dateCharityAuditorsReportOnRevisedAccounts')?.markAsTouched();
            }

          }
          else {
            this.AuditorForm.get('dateofAudit')?.setErrors({ required: true });
            this.AuditorForm.get('approvedbyAuditor')?.setErrors({ required: true });
            this.AuditorForm.get('dateofAudit')?.markAsTouched();
            if (this.account_Type == 'Amended') {
              this.AuditorForm.get('dateCharityAuditorsReportOnRevisedAccounts')?.setErrors({ required: true });
              this.AuditorForm.get('dateCharityAuditorsReportOnRevisedAccounts')?.markAsTouched();
            }
          }
        }
        else if (dateControl?.value == null) {
          if (dateControl?.errors?.['InvalidDate']) {
            this.AuditorForm.get('dateofAudit')?.setErrors({ InvalidDate: true })
          }
          else {
            this.AuditorForm.get('dateofAudit')?.setErrors({ required: true });
            this.AuditorForm.get('dateofAudit')?.markAsTouched();
          }

        }

        else if (reviseddate?.value == null && this.account_Type == 'Amended') {
          if (reviseddate?.errors?.['InvalidDate']) {
            this.AuditorForm.get('dateCharityAuditorsReportOnRevisedAccounts')?.setErrors({ InvalidDate: true })
          }
          else {
            this.AuditorForm.get('dateCharityAuditorsReportOnRevisedAccounts')?.setErrors({ required: true });
            this.AuditorForm.get('dateCharityAuditorsReportOnRevisedAccounts')?.markAsTouched();
          }
        }

        else if (auditorControl?.value == null) {
          this.AuditorForm.get('approvedbyAuditor')?.setErrors({ required: true });
        }

        if (this.account_Type == 'Amended') {
          dateControl?.markAsTouched();
          auditorControl?.markAsTouched();
          reviseddate?.markAsTouched();
        }
        else {
          dateControl?.markAsTouched();
          auditorControl?.markAsTouched();
        }
        const opinion = this.AuditorForm.controls['opinion']?.value;
        if (opinion == '' || opinion == "<p></p>") {
          Swal.fire({
            html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel"></h5> <p class= "f-s-14 p-0  f-w-400 text-black" > Opinion must be required</p>',
            iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
            confirmButtonText: "OK",
            showCancelButton: false,
            allowOutsideClick: false
          }).then((result) => {
            if (result.isConfirmed) {
              return true
            } else {
              return false
            }
          })
          return
        }
        if (this.account_Type == 'Amended') {
          if (dateControl?.invalid || auditorControl?.invalid || reviseddate?.invalid) {
            return; // prevent save
          }
          const auditor = this.filteredAdvisors?.find((x: any) => x.advisorsId ==
            this.AuditorForm.get('approvedbyAuditor')?.value);
          const description = this.AuditorForm.get('individual_Description')?.value;
          let hasDescription = false;
          if (typeof description === 'string') {
            const plainText = description
              .replace(/<[^>]*>/g, '')
              .replace(/&nbsp;/g, '')
              .trim();
            hasDescription = plainText.length > 0;
          }
          else if (description && typeof description === 'object') {
            const jsonText = JSON.stringify(description);
            hasDescription = jsonText.includes('"text":"');
          }
          if (this.audited_Type === 'companiesact2006' && auditor?.advisor_audited_Type === 'Individual Charity Auditor' && this.beforeYear && !hasDescription) {
            Swal.fire({
              html: `<h5 class="f-s-16 f-w-600 text-black">Description Required</h5><p class="f-s-14 p-0 m-y-5 f-w-400 text-black">As you selected an Individual Charity Auditor under Companies Act 2006, the "Description Reasons If Senior Statutory Auditor Name Not Disclosed" field is mandatory.</p>`,
              iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
              confirmButtonText: 'OK',
              allowOutsideClick: false
            }); return;
          }
          this.save()
        }

        else {
          const auditor = this.filteredAdvisors?.find((x: any) => x.advisorsId ==
            this.AuditorForm.get('approvedbyAuditor')?.value);
          const description = this.AuditorForm.get('individual_Description')?.value;
          let hasDescription = false;
          if (typeof description === 'string') {
            const plainText = description
              .replace(/<[^>]*>/g, '')
              .replace(/&nbsp;/g, '')
              .trim();
            hasDescription = plainText.length > 0;
          }
          else if (description && typeof description === 'object') {
            const jsonText = JSON.stringify(description);
            hasDescription = jsonText.includes('"text":"');
          }
          if (this.audited_Type === 'companiesact2006' && auditor?.advisor_audited_Type === 'Individual Charity Auditor' && this.beforeYear && !hasDescription) {
            Swal.fire({
              html: `<h5 class="f-s-16 f-w-600 text-black">Description Required</h5><p class="f-s-14 p-0 m-y-5 f-w-400 text-black">As you selected an Individual Charity Auditor under Companies Act 2006, the "Description Reasons If Senior Statutory Auditor Name Not Disclosed" field is mandatory.</p>`,
              iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
              confirmButtonText: 'OK',
              allowOutsideClick: false
            }); return;
          }
          const opinion = this.AuditorForm.controls['opinion']?.value;
          if (opinion == '' || opinion == "<p></p>") {
            Swal.fire({
              html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel"></h5> <p class= "f-s-14 p-0  f-w-400 text-black" > Opinion must be required</p>',
              iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
              confirmButtonText: "OK",
              showCancelButton: false,
              allowOutsideClick: false
            }).then((result) => {
              if (result.isConfirmed) {
                return true
              } else {
                return false
              }
            })
            return
          }
          if (dateControl?.invalid || auditorControl?.invalid) {
            return; // prevent save
          }
          this.save()
        }
      }
      else {
        const opinion = this.AuditorForm.controls['opinion']?.value;
        if (opinion == '' || opinion == "<p></p>") {
          Swal.fire({
            html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel"></h5> <p class= "f-s-14 p-0  f-w-400 text-black" > Opinion must be required</p>',
            iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
            confirmButtonText: "OK",
            showCancelButton: false,
            allowOutsideClick: false
          }).then((result) => {
            if (result.isConfirmed) {
              return true
            } else {
              return false
            }
          })
          return
        }
      }
    }
  }



  ischecked: boolean = false
  setVisibility(event: MatRadioChange) {


    if (this.apFinalised) {
      this.ischecked = event.value === 'Yes';
      return;
    }
    this.ischecked = event.value === 'Yes';
    this.DefaultStatement('opinion');
    this.dirty();
  }
  save() {
    debugger
    this.AuditorForm.getRawValue()

    //this.AuditorForm.controls['centralUserId'].setValue((localStorage.getItem("CentralUserId") ? +localStorage.getItem("CentralUserId")! : 0))
    //this.AuditorForm.controls['userId'].setValue(localStorage.getItem("userID") ? +localStorage.getItem("CurrentuserID")! : 0)
    //this.AuditorForm.controls['charityID'].setValue(localStorage.getItem("charityId") ? +localStorage.getItem("charityId")! : 0)
    //this.AuditorForm.controls['financialPeriodsID'].setValue(localStorage.getItem("currentPeriod") ? +localStorage.getItem("currentPeriod")! : 0)
    // console.log(this.AuditorForm.controls['dateofAudit'].value)
    this.AuditorForm.controls['dateofAudit'].setValue(moment(this.AuditorForm.controls['dateofAudit'].value).format('YYYY-MM-DD'))
    this.AuditorForm.controls['accountType'].setValue((localStorage.getItem("account_Type") ? localStorage.getItem("account_Type")! : ''))
    if (this.account_Type == 'Amended') {
      this.AuditorForm.controls['dateCharityAuditorsReportOnRevisedAccounts'].setValue(moment(this.AuditorForm.controls['dateCharityAuditorsReportOnRevisedAccounts'].value).format('YYYY-MM-DD'))
    }
    // console.log(this.AuditorForm.controls['dateofAudit'].value)
    this.AuditorForm.controls['opiniontype'].setValue(this.ischecked)
    //this.datePipe.transform(data[0].JournalDate, "MM/dd/yyyy"
    //console.log(this.datePipe.transform(this.AuditorForm.controls['dateofAudit'].getRawValue(), "MM/dd/yyyy"))
    const description = this.AuditorForm.get('individual_Description')?.value;

    if (description && typeof description === 'object') {

      const text = description?.content?.[0]?.content?.[0]?.text || '';

      this.AuditorForm.get('individual_Description')?.setValue(text);
    }
    this.Auditors_report.SaveAuditorsReport(this.AuditorForm.getRawValue()).subscribe((data: BaseSearchModel<any>) => {
      if (data.entity[0] != null)
        this.AuditorForm.controls['auditorsReportId'].setValue(data.entity[0].auditorsReportId)
      this.router.navigate(['final-accounts']);
    })
  }
  orginalStatment() {
    this.defaultStatements = {

      basisofOpinion: `<p>We conducted our audit in accordance with International Standards on Auditing (UK) (ISAs (UK)) and applicable law. Our responsibilities under those standards are further described in the auditor's responsibilities for the audit of the financial statements section of our report. We are independent of the group in accordance with the ethical requirements that are relevant to our audit of the financial statements in the UK, including the FRC’s Ethical Standard, and we have fulfilled our other ethical responsibilities in accordance with these requirements. We believe that the audit evidence we have obtained is sufficient and appropriate to provide a basis for our opinion.</p>`,
      opinion: `
    <p>We have audited the financial statements of ${localStorage.getItem("charity_Name")} for the year ended ${moment(this.BasicInformation[0]?.current_AP_End_Date).format('DD/MM/YYYY')}

 which comprise the Consolidated Statement of Financial Activities, the Consolidated and Parent Charitable Company Balance Sheets, the Consolidated Statement of Cash Flows and notes to the financial statements, including a summary of significant accounting policies. The financial reporting framework that has been applied in their preparation is applicable law and United Kingdom Accounting Standards, including Financial Reporting Standard 102 The Financial Reporting Standard applicable in the UK and Republic of Ireland (United Kingdom Generally Accepted Accounting Practice).</p>
    <p>In our opinion, the financial statements:</p>
    <ul>
      <li>give a true and fair view of the state of the Group’s and of the Parent Charitable Company’s affairs as at 31 July 2019 and of the Group’s income and expenditure and application of resources for the year then ended;</li>
      <li>have been properly prepared in accordance with United Kingdom Generally Accepted Accounting Practice; and</li>
      <li>have been prepared in accordance with the requirements of the Companies Act 2006.</li>
    </ul>
     `,
      opinion_yes: `
    <p>We have audited the financial statements of ${localStorage.getItem("charity_Name")} for the year ended  ${moment(this.BasicInformation[0]?.current_AP_End_Date).format('DD/MM/YYYY')}
 which comprise the Consolidated Statement of Financial Activities, the Consolidated and Parent Charitable Company Balance Sheets, the Consolidated Statement of Cash Flows and notes to the financial statements, including a summary of significant accounting policies. The financial reporting framework that has been applied in their preparation is applicable law and United Kingdom Accounting Standards, including Financial Reporting Standard 102 The Financial Reporting Standard applicable in the UK and Republic of Ireland (United Kingdom Generally Accepted Accounting Practice).</p>
`,
      opinion_no: `
    <p>We have audited the financial statements of ${localStorage.getItem("charity_Name")} for the year ended  ${moment(this.BasicInformation[0]?.current_AP_End_Date).format('DD/MM/YYYY')}

 which comprise the Consolidated Statement of Financial Activities, the Consolidated and Parent Charitable Company Balance Sheets, the Consolidated Statement of Cash Flows and notes to the financial statements, including a summary of significant accounting policies. The financial reporting framework that has been applied in their preparation is applicable law and United Kingdom Accounting Standards, including Financial Reporting Standard 102 The Financial Reporting Standard applicable in the UK and Republic of Ireland (United Kingdom Generally Accepted Accounting Practice).</p>
<p>In our opinion, the financial statements:</p>
    <ul>
      <li>give a true and fair view of the state of the Group’s and of the Parent Charitable Company’s affairs as at 31 July 2019 and of the Group’s income and expenditure and application of resources for the year then ended;</li>
      <li>have been properly prepared in accordance with United Kingdom Generally Accepted Accounting Practice; and</li>
      <li>have been prepared in accordance with the requirements of the Companies Act 2006.</li>
    </ul>
  `,
      conclusions: `<p>In auditing the financial statements, we have concluded that the trustees' use of the going concern basis of accounting in the preparation of the financial statements is appropriate.</p>
<p>Based on the work we have performed, we have not identified any material uncertainties relating to events or conditions that, individually or collectively, may cast significant doubt on the group’s or the parent charity’s ability to continue as a going concern for a period of at least twelve months from when the financial statements are authorised for issue.</p>
<p>Our responsibilities and the responsibilities of the trustees with respect to going concern are described in the relevant sections of this report.</p>`,
      otherInformation: `<p>The other information comprises the information included in the annual report, other than the financial statements and our auditor’s report thereon. The trustees are responsible for the other information. Our opinion on the financial statements does not cover the other information and, except to the extent otherwise explicitly stated in our report, we do not express any form of assurance conclusion thereon.</p>
<p>In connection with our audit of the financial statements, our responsibility is to read the other information and, in doing so, consider whether the other information is materially inconsistent with the financial statements or our knowledge obtained in the audit or otherwise appears to be materially misstated. If we identify such material inconsistencies or apparent material misstatements, we are required to determine whether there is a material misstatement in the financial statements or a material misstatement of the other information. If, based on the work we have performed, we conclude that there is a material misstatement of this other information, we are required to report that fact.</p>
<p>We have nothing to report in this regard.</p>`,
      othermattersprescribed: `<p>In our opinion, based on the work undertaken in the course of the audit:</p>
<ul>
<li> the information given in the trustees’ annual report including the strategic report for the financial year for which the financial statements are prepared is consistent with the financial statements; and</li>
<li> the trustees’ annual report including the strategic report has been prepared in accordance with applicable legal requirements.</li>
</ul>`,
      reportbyexception: `<p>In the light of the knowledge and understanding of the group and the parent charity and its environment obtained in the course of the audit, we have not identified material misstatements in the trustees’ annual report.</p>
<p>We have nothing to report in respect of the following matters where the Companies Act 2006 requires us to report to you if, in our opinion:</p>
<ul>
<li>adequate accounting records have not been kept by the parent charity, or returns adequate for our audit have not been received from branches not visited by us; or </li>
<li>the parent charity’s financial statements are not in agreement with the accounting records and returns; or</li>
<li>certain disclosures of trustees’ remuneration specified by law are not made; or</li>
<li>we have not received all the information and explanations we require for our audit; or</li>
<li>the trustees were not entitled to prepare the financial statements in accordance with the small companies’ regime and take advantage of the small companies' exemptions in preparing the trustees annual report and from the requirement to prepare a strategic report.</li>
</ul>`,
      responsibilitiesoftrustees: `<p>As explained more fully in the trustees' responsibilities statement, the trustees (who are also the directors for the purposes of company law) are responsible for the preparation of the financial statements and for being satisfied that they give a true and fair view, and for such internal control as the trustees determine is necessary to enable the preparation of financial statements that are free from material misstatement, whether due to fraud or error.</p>
<p> In preparing the financial statements, the trustees are responsible for assessing the group’s and the parent charity's ability to continue as a going concern, disclosing, as applicable, matters related to going concern and using the going concern basis of accounting unless the trustees either intend to liquidate the group or the parent charity or to cease operations, or have no realistic alternative but to do so.</p>`,
      auditorresponsibilities: `<p>Our objectives are to obtain reasonable assurance about whether the financial statements as a whole are free from material misstatement, whether due to fraud or error, and to issue an auditor’s report that includes our opinion. Reasonable assurance is a high level of assurance, but is not a guarantee that an audit conducted in accordance with ISAs (UK) will always detect a material misstatement when it exists. Misstatements can arise from fraud or error and are considered material if, individually or in the aggregate, they could reasonably be expected to influence the economic decisions of users taken on the basis of these financial statements.</p>
<p>Irregularities, including fraud, are instances of non-compliance with laws and regulations. We design procedures in line with our responsibilities, outlined above, to detect material misstatements in respect of irregularities, including fraud.</p>
<p> The extent to which our procedures are capable of detecting irregularities, including fraud is detailed below:</p>
<ul>
   <li> We obtained an understanding of the legal and regulatory frameworks that are applicable to the group through discussion with the trustees and identified financial reporting legislation, charity legislation and media legislation as being most significant to these financial statements.</li>
   <li> We communicated these identified frameworks amongst our audit team and remained alert to any indications of non-compliance throughout the audit. We ensured that the engagement team had sufficient competence and capability to identify or recognise non-compliance with the laws and regulations. </li>
   <li> We discussed with the trustees the policies and procedures regarding compliance with these legal and regulatory frameworks. </li>
   <li> We assessed the susceptibility of the group's financial statements to material misstatement due to noncompliance with legal and regulatory frameworks, including how fraud might occur, by enquiry with the trustees during the planning and finalisation stages of our audit. The susceptibility to such material misstatement was determined to be low.</li>
   <li> Based on this understanding, we designed our audit procedures to identify non-compliance with the identified legal and regulatory frameworks, which were part of our procedures on the related financial statement items. Our procedures included reviewing the group’s internal controls policies and procedures, reviewing the minutes of board meetings and correspondence with regulatory bodies including HM Revenue & Customs, testing transactions outside the normal course of the business and journal entries, and discussions with the management. </li>
</ul>
<p> Owing to the inherent limitations of an audit, there is an unavoidable risk that we may not have detected some material misstatements in the financial statements, even though we have properly planned and performed our audit in accordance with auditing standards. For example, the further removed non-compliance with laws and regulations (irregularities) is from the events and transactions reflected in the financial statements, the less likely the inherently limited procedures required by auditing standards would identify it. In addition, as with any audit, there remained a higher risk of non-detection of irregularities, as these may involve collusion, forgery, intentional omissions, misrepresentations, or the override of internal controls. We are not responsible for preventing noncompliance and cannot be expected to detect non-compliance with all laws and regulations.</p>
<p> A further description of our responsibilities for the audit of the financial statements is located on the Financial Reporting Council’s website at www.frc.org.uk/auditorsresponsibilities. This description forms part of our auditor’s report.</p>
`,

      useofthisreport: `<p> This report is made solely to the charity's members, as a body, in accordance with Chapter 3 of Part 16 of the Companies Act 2006. Our audit work has been undertaken so that we might state to the charity's members those matters we are required to state to them in an auditor's report and for no other purpose. To the fullest extent permitted by law, we do not accept or assume responsibility to anyone other than the charity and the charity's members as a body, for our audit work, for this report, or for the opinions we have formed.
</p>`,
      qualifiedrevisedstatement: `<p>We have audited the revised financial statements of ${localStorage.getItem("charity_Name")} for the year ended ${moment(this.BasicInformation[0]?.current_AP_End_Date).format('DD/MM/YYYY')} which comprise the Consolidated Statement of Financial Activities, the Consolidated and Parent Charitable Company Balance Sheets, the Consolidated Statement of Cash Flows and notes to the financial statements, including a summary of significant accounting policies. The financial reporting framework that has been applied in their preparation is applicable law and United Kingdom Accounting Standards, including Financial Reporting Standard 102 The Financial Reporting Standard applicable in the UK and Republic of Ireland (United Kingdom Generally Accepted Accounting Practice).</p>
      <p>These revised financial statements replace the original financial statements approved by the [Trustee] on [Revised_Approval_Date] and consist of the attached supplementary note together with the original financial statements circulated to members.</p>
      <p>The revised financial statements have been prepared in accordance with The Companies (Revision of Defective Accounts and Reports) Regulations 2008 and as such do not consider events which have taken place after the date on which the original financial statements were approved.</p>`,

      unqualifiedrevisedstatement: `<p>We have audited the revised financial statements of ${localStorage.getItem("charity_Name")} for the year ended ${moment(this.BasicInformation[0]?.current_AP_End_Date).format('DD/MM/YYYY')} which comprise the Consolidated Statement of Financial Activities, the Consolidated and Parent Charitable Company Balance Sheets, the Consolidated Statement of Cash Flows and notes to the financial statements, including a summary of significant accounting policies. The financial reporting framework that has been applied in their preparation is applicable law and United Kingdom Accounting Standards, including Financial Reporting Standard 102 The Financial Reporting Standard applicable in the UK and Republic of Ireland (United Kingdom Generally Accepted Accounting Practice).</p>
      <p>These revised financial statements replace the original financial statements approved by the [Trustee] on [Revised_Approval_Date] and consist of the attached supplementary note together with the original financial statements circulated to members.</p>
      <p>The revised financial statements have been prepared in accordance with The Companies (Revision of Defective Accounts and Reports) Regulations 2008 and as such do not consider events which have taken place after the date on which the original financial statements were approved.</p>
        <p> In our opinion, the revised financial statements: </p>
          <ul>
          <li>give a true and fair view of the state of the Group’s and of the Parent Charitable Company’s affairs as at 31 July 2019 and of the Group’s income and expenditure and application of resources for the year then ended;</li>
      <li> have been properly prepared in accordance with United Kingdom Generally Accepted Accounting Practice; and </li>
        <li> have been prepared in accordance with the requirements of the Companies Act 2006. </li>
          </ul>`
      ,

    }
  }
  Getbasicinformation() {


    const period = localStorage.getItem('currentPeriod');
    const charityId = localStorage.getItem('currentCharityID');
    this.Charity_Service.Getbasicinfo(charityId, period).subscribe((data: any) => {
      debugger
      this.BasicInformation = data
      if (this.BasicInformation && this.BasicInformation.length > 0) {

        const info = this.BasicInformation[0];

        let date = info?.current_AP_End_Date;
        let formatteddate = date.split("T")[0];
        if (formatteddate >= '2026-04-01') {
          this.beforeYear = false;
        } else {
          this.beforeYear = true;
        }

        this.GetProfessionalAdvisorsDetails()
        this.audited_Type = (info.audited_Type || '').toLowerCase();
        this.account_Type = (info.account_Type || '');


        localStorage.setItem('audited_Type', this.audited_Type);
        localStorage.setItem('account_Type', this.account_Type);


        this.orginalStatment();
        this.GetAuditorsReport();
      }


    })
  }
  DefaultStatement(formControlName: any) {
    debugger

    if (this.apFinalised) {
      return;
    }

    var selected = null
    if (this.account_Type == 'Amended' && formControlName == 'opinion') {
      if (this.ischecked && formControlName == 'opinion') {
        selected = this.defaultStatements['qualifiedrevisedstatement'];
      } else {
        selected = this.defaultStatements['unqualifiedrevisedstatement'];
      }
    }
    else {
      if (this.ischecked && formControlName == 'opinion') {
        selected = this.defaultStatements['opinion_yes'];
      } else {
        selected = this.defaultStatements[formControlName];
      }
    }
    if (selected) {
      this.AuditorForm.patchValue({
        [formControlName]: selected
      });
    }
  }
  GetAuditorsReport() {
    const newAmendCycle = localStorage.getItem('NewAmendCycle') === 'true';
    var acctype = localStorage.getItem("account_Type") ? localStorage.getItem("account_Type")! : ''
    this.Auditors_report.GetAuditorsReport(+localStorage.getItem("currentPeriod")!).subscribe((data: any) => {
      debugger
      if (data) {
        this.createAuditor();
        if (data?.approvedbyAuditor) { this.selectedAuditorId = data.approvedbyAuditor; }
        this.AuditorForm.patchValue(data);
        //this.handleApprovedByAuditorState();
        if (this.account_Type === 'Amended' && this.AuditorForm.controls['dateofAudit']?.value) {
          this.AuditorForm.controls['dateofAudit']?.disable()
        }
        this.ischecked = data.opiniontype;

        if (acctype == data.accountType) {
          if (acctype === 'Amended' && data.amendSubmissionCount >= 0 && localStorage.getItem('NewAmendCycle') === 'true') {
            this.DefaultStatement('opinion');
            localStorage.removeItem('NewAmendCycle');
          } else {
            this.AuditorForm.get('opinion')?.setValue(data?.opinion);
          }
        }
        else if (acctype == 'Amended') {
          if (this.ischecked) {
            var selected = this.defaultStatements['qualifiedrevisedstatement'];
            this.AuditorForm.get('opinion')?.setValue(selected);
          } else {
            var selected = this.defaultStatements['unqualifiedrevisedstatement'];
            this.AuditorForm.get('opinion')?.setValue(selected);
          }
        }
        else {
          if (!this.apFinalised) {
            this.DefaultStatement('opinion');
          }
        }
      }
      //this.AuditorForm.controls['approvedbyAuditor'].setValue(this.filteredAdvisors[0]?.advisorsId);
      //if (this.AuditorForm.controls['approvedbyAuditor']?.value) {
      //  this.AuditorForm.controls['approvedbyAuditor'].disable()
      //}

    })
  }
  defaultStatements: { [key: string]: string } = {

    basisofOpinion: `<p>We conducted our audit in accordance with International Standards on Auditing (UK) (ISAs (UK)) and applicable law. Our responsibilities under those standards are further described in the auditor's responsibilities for the audit of the financial statements section of our report. We are independent of the group in accordance with the ethical requirements that are relevant to our audit of the financial statements in the UK, including the FRC’s Ethical Standard, and we have fulfilled our other ethical responsibilities in accordance with these requirements. We believe that the audit evidence we have obtained is sufficient and appropriate to provide a basis for our opinion.</p>`,
    opinion: `
    <p>We have audited the financial statements of ${moment(this.BasicInformation[0]?.current_AP_End_Date).format('DD/MM/YYYY')}

 which comprise the Consolidated Statement of Financial Activities, the Consolidated and Parent Charitable Company Balance Sheets, the Consolidated Statement of Cash Flows and notes to the financial statements, including a summary of significant accounting policies. The financial reporting framework that has been applied in their preparation is applicable law and United Kingdom Accounting Standards, including Financial Reporting Standard 102 The Financial Reporting Standard applicable in the UK and Republic of Ireland (United Kingdom Generally Accepted Accounting Practice).</p>
    <p>In our opinion, the financial statements:</p>
    <ul>
      <li>give a true and fair view of the state of the Group’s and of the Parent Charitable Company’s affairs as at 31 July 2019 and of the Group’s income and expenditure and application of resources for the year then ended;</li>
      <li>have been properly prepared in accordance with United Kingdom Generally Accepted Accounting Practice; and</li>
      <li>have been prepared in accordance with the requirements of the Companies Act 2006.</li>
    </ul>
     `,
    opinion_yes: `
    <p>We have audited the financial statements of ${localStorage.getItem("charity_Name")} for the year ended  ${moment(this.BasicInformation[0]?.current_AP_End_Date).format('DD/MM/YYYY')}
 which comprise the Consolidated Statement of Financial Activities, the Consolidated and Parent Charitable Company Balance Sheets, the Consolidated Statement of Cash Flows and notes to the financial statements, including a summary of significant accounting policies. The financial reporting framework that has been applied in their preparation is applicable law and United Kingdom Accounting Standards, including Financial Reporting Standard 102 The Financial Reporting Standard applicable in the UK and Republic of Ireland (United Kingdom Generally Accepted Accounting Practice).</p>
      `,
    opinion_no: `
    <p>We have audited the financial statements of ${localStorage.getItem("charity_Name")} for the year ended  ${moment(this.BasicInformation[0]?.current_AP_End_Date).format('DD/MM/YYYY')}

 which comprise the Consolidated Statement of Financial Activities, the Consolidated and Parent Charitable Company Balance Sheets, the Consolidated Statement of Cash Flows and notes to the financial statements, including a summary of significant accounting policies. The financial reporting framework that has been applied in their preparation is applicable law and United Kingdom Accounting Standards, including Financial Reporting Standard 102 The Financial Reporting Standard applicable in the UK and Republic of Ireland (United Kingdom Generally Accepted Accounting Practice).</p>
<p>In our opinion, the financial statements:</p>
    <ul>
      <li>give a true and fair view of the state of the Group’s and of the Parent Charitable Company’s affairs as at 31 July 2019 and of the Group’s income and expenditure and application of resources for the year then ended;</li>
      <li>have been properly prepared in accordance with United Kingdom Generally Accepted Accounting Practice; and</li>
      <li>have been prepared in accordance with the requirements of the Companies Act 2006.</li>
    </ul>
  `,
    conclusions: `<p>In auditing the financial statements, we have concluded that the trustees' use of the going concern basis of accounting in the preparation of the financial statements is appropriate.</p>
<p>Based on the work we have performed, we have not identified any material uncertainties relating to events or conditions that, individually or collectively, may cast significant doubt on the group’s or the parent charity’s ability to continue as a going concern for a period of at least twelve months from when the financial statements are authorised for issue.</p>
<p>Our responsibilities and the responsibilities of the trustees with respect to going concern are described in the relevant sections of this report.</p>`,
    otherInformation: `<p>The other information comprises the information included in the annual report, other than the financial statements and our auditor’s report thereon. The trustees are responsible for the other information. Our opinion on the financial statements does not cover the other information and, except to the extent otherwise explicitly stated in our report, we do not express any form of assurance conclusion thereon.</p>
<p>In connection with our audit of the financial statements, our responsibility is to read the other information and, in doing so, consider whether the other information is materially inconsistent with the financial statements or our knowledge obtained in the audit or otherwise appears to be materially misstated. If we identify such material inconsistencies or apparent material misstatements, we are required to determine whether there is a material misstatement in the financial statements or a material misstatement of the other information. If, based on the work we have performed, we conclude that there is a material misstatement of this other information, we are required to report that fact.</p>
<p>We have nothing to report in this regard.</p>`,
    othermattersprescribed: `<p>In our opinion, based on the work undertaken in the course of the audit:</p>
<ul>
<li> the information given in the trustees’ annual report including the strategic report for the financial year for which the financial statements are prepared is consistent with the financial statements; and</li>
<li> the trustees’ annual report including the strategic report has been prepared in accordance with applicable legal requirements.</li>
</ul>`,
    reportbyexception: `<p>In the light of the knowledge and understanding of the group and the parent charity and its environment obtained in the course of the audit, we have not identified material misstatements in the trustees’ annual report.</p>
<p>We have nothing to report in respect of the following matters where the Companies Act 2006 requires us to report to you if, in our opinion:</p>
<ul>
<li>adequate accounting records have not been kept by the parent charity, or returns adequate for our audit have not been received from branches not visited by us; or </li>
<li>the parent charity’s financial statements are not in agreement with the accounting records and returns; or</li>
<li>certain disclosures of trustees’ remuneration specified by law are not made; or</li>
<li>we have not received all the information and explanations we require for our audit; or</li>
<li>the trustees were not entitled to prepare the financial statements in accordance with the small companies’ regime and take advantage of the small companies' exemptions in preparing the trustees annual report and from the requirement to prepare a strategic report.</li>
</ul>`,
    responsibilitiesoftrustees: `<p>As explained more fully in the trustees' responsibilities statement, the trustees (who are also the directors for the purposes of company law) are responsible for the preparation of the financial statements and for being satisfied that they give a true and fair view, and for such internal control as the trustees determine is necessary to enable the preparation of financial statements that are free from material misstatement, whether due to fraud or error.</p>
<p> In preparing the financial statements, the trustees are responsible for assessing the group’s and the parent charity's ability to continue as a going concern, disclosing, as applicable, matters related to going concern and using the going concern basis of accounting unless the trustees either intend to liquidate the group or the parent charity or to cease operations, or have no realistic alternative but to do so.</p>`,
    auditorresponsibilities: `<p>Our objectives are to obtain reasonable assurance about whether the financial statements as a whole are free from material misstatement, whether due to fraud or error, and to issue an auditor’s report that includes our opinion. Reasonable assurance is a high level of assurance, but is not a guarantee that an audit conducted in accordance with ISAs (UK) will always detect a material misstatement when it exists. Misstatements can arise from fraud or error and are considered material if, individually or in the aggregate, they could reasonably be expected to influence the economic decisions of users taken on the basis of these financial statements.</p>
<p>Irregularities, including fraud, are instances of non-compliance with laws and regulations. We design procedures in line with our responsibilities, outlined above, to detect material misstatements in respect of irregularities, including fraud.</p>
<p> The extent to which our procedures are capable of detecting irregularities, including fraud is detailed below:</p>
<ul>
   <li> We obtained an understanding of the legal and regulatory frameworks that are applicable to the group through discussion with the trustees and identified financial reporting legislation, charity legislation and media legislation as being most significant to these financial statements.</li>
   <li> We communicated these identified frameworks amongst our audit team and remained alert to any indications of non-compliance throughout the audit. We ensured that the engagement team had sufficient competence and capability to identify or recognise non-compliance with the laws and regulations. </li>
   <li> We discussed with the trustees the policies and procedures regarding compliance with these legal and regulatory frameworks. </li>
   <li> We assessed the susceptibility of the group's financial statements to material misstatement due to noncompliance with legal and regulatory frameworks, including how fraud might occur, by enquiry with the trustees during the planning and finalisation stages of our audit. The susceptibility to such material misstatement was determined to be low.</li>
   <li> Based on this understanding, we designed our audit procedures to identify non-compliance with the identified legal and regulatory frameworks, which were part of our procedures on the related financial statement items. Our procedures included reviewing the group’s internal controls policies and procedures, reviewing the minutes of board meetings and correspondence with regulatory bodies including HM Revenue & Customs, testing transactions outside the normal course of the business and journal entries, and discussions with the management. </li>
</ul>
<p> Owing to the inherent limitations of an audit, there is an unavoidable risk that we may not have detected some material misstatements in the financial statements, even though we have properly planned and performed our audit in accordance with auditing standards. For example, the further removed non-compliance with laws and regulations (irregularities) is from the events and transactions reflected in the financial statements, the less likely the inherently limited procedures required by auditing standards would identify it. In addition, as with any audit, there remained a higher risk of non-detection of irregularities, as these may involve collusion, forgery, intentional omissions, misrepresentations, or the override of internal controls. We are not responsible for preventing noncompliance and cannot be expected to detect non-compliance with all laws and regulations.</p>
<p> A further description of our responsibilities for the audit of the financial statements is located on the Financial Reporting Council’s website at www.frc.org.uk/auditorsresponsibilities. This description forms part of our auditor’s report.</p>
`,
    qualifiedrevisedstatement: `<p>We have audited the revised financial statements of ${localStorage.getItem("charity_Name")} for the year ended ${moment(this.BasicInformation[0]?.current_AP_End_Date).format('DD/MM/YYYY')} which comprise the Consolidated Statement of Financial Activities, the Consolidated and Parent Charitable Company Balance Sheets, the Consolidated Statement of Cash Flows and notes to the financial statements, including a summary of significant accounting policies. The financial reporting framework that has been applied in their preparation is applicable law and United Kingdom Accounting Standards, including Financial Reporting Standard 102 The Financial Reporting Standard applicable in the UK and Republic of Ireland (United Kingdom Generally Accepted Accounting Practice).</p>
      <p>These revised financial statements replace the original financial statements approved by the [Trustee] on [Revised_Approval_Date] and consist of the attached supplementary note together with the original financial statements circulated to members.</p>
      <p>The revised financial statements have been prepared in accordance with The Companies (Revision of Defective Accounts and Reports) Regulations 2008 and as such do not consider events which have taken place after the date on which the original financial statements were approved.</p>`,

    unqualifiedrevisedstatement: `<p>We have audited the revised financial statements of ${localStorage.getItem("charity_Name")} for the year ended ${moment(this.BasicInformation[0]?.current_AP_End_Date).format('DD/MM/YYYY')} which comprise the Consolidated Statement of Financial Activities, the Consolidated and Parent Charitable Company Balance Sheets, the Consolidated Statement of Cash Flows and notes to the financial statements, including a summary of significant accounting policies. The financial reporting framework that has been applied in their preparation is applicable law and United Kingdom Accounting Standards, including Financial Reporting Standard 102 The Financial Reporting Standard applicable in the UK and Republic of Ireland (United Kingdom Generally Accepted Accounting Practice).</p>
      <p>These revised financial statements replace the original financial statements approved by the [Trustee] on [Revised_Approval_Date] and consist of the attached supplementary note together with the original financial statements circulated to members.</p>
      <p>The revised financial statements have been prepared in accordance with The Companies (Revision of Defective Accounts and Reports) Regulations 2008 and as such do not consider events which have taken place after the date on which the original financial statements were approved.</p>
        <p> In our opinion, the revised financial statements: </p>
          <ul>
          <li>give a true and fair view of the state of the Group’s and of the Parent Charitable Company’s affairs as at 31 July 2019 and of the Group’s income and expenditure and application of resources for the year then ended;</li>
      <li> have been properly prepared in accordance with United Kingdom Generally Accepted Accounting Practice; and </li>
        <li> have been prepared in accordance with the requirements of the Companies Act 2006. </li>
          </ul>`
    ,

    useofthisreport: `<p> This report is made solely to the charity's members, as a body, in accordance with Chapter 3 of Part 16 of the Companies Act 2006. Our audit work has been undertaken so that we might state to the charity's members those matters we are required to state to them in an auditor's report and for no other purpose. To the fullest extent permitted by law, we do not accept or assume responsibility to anyone other than the charity and the charity's members as a body, for our audit work, for this report, or for the opinions we have formed.
</p>`

  }



  vlddateofapp(event: any) {

    // this.form.get('approvalDate')?.setErrors(null)
    if ((event.target.value == null || event.target.value == "") && !(+this.AuditorForm.get('dateofAudit')?.getRawValue() > 0) && !(+this.AuditorForm.get('dateofAudit')?.getRawValue() > 0)) {
      this.AuditorForm.get('dateofAudit')?.setErrors({ required: true })
      this.AuditorForm.get('dateofAudit')?.markAsTouched()
    } else {
      this.AuditorForm.get('dateofAudit')?.setErrors(null)
      this.AuditorForm.get('dateofAudit')?.markAsTouched()

      this.CurrentDate_Validate(event)
    }

  }
  vldofrevised(event: any) {
    debugger
    if ((this.account_Type == 'Amended' && !event.target.value) || (this.account_Type == 'Amended' && event.target.value == '')) {
      this.AuditorForm.get('dateCharityAuditorsReportOnRevisedAccounts')?.setErrors({ required: true })
      this.AuditorForm.get('dateCharityAuditorsReportOnRevisedAccounts')?.markAsTouched()
    }
    else {
      if (this.account_Type == 'Amended') {
        this.AuditorForm.get('dateCharityAuditorsReportOnRevisedAccounts')?.markAsTouched()
        this.AuditorForm.get('dateCharityAuditorsReportOnRevisedAccounts')?.setErrors(null)
        this.RevisedDate_Validate(event)
      }
    }
  }

  CurrentDate_Validate(Event?: any) {
    debugger
    const inputValue = Event?.target?.value;
    const momentDate = moment(inputValue, 'DD/MM/YYYY', true);
    const isValidDate = momentDate.isValid();

    const acpStart = moment(this.BasicInformation[0].current_AP_Start_Date); // start date
    const acpEnd = moment(this.BasicInformation[0].current_AP_End_Date);     // end date
    const today = moment(); // current date
    const originalDate = moment(this.AuditorForm.get('dateofAudit')?.value);
    const revisedDate = moment(this.AuditorForm.get('dateCharityAuditorsReportOnRevisedAccounts')?.value)

    if (!isValidDate) {
      this.AuditorForm.get('dateofAudit')?.setErrors({ InvalidDate: true });
    } else if (momentDate.isAfter(today, 'day')) {
      this.AuditorForm.get('dateofAudit')?.setErrors({ IsAfterToday: true });
    } else if (momentDate.isBefore(acpStart, 'day')) {
      this.AuditorForm.get('dateofAudit')?.setErrors({ BeforeAccountingPeriod: true });
    }
    else if ((momentDate.isAfter(revisedDate, 'day')) && this.AuditorForm.get('dateCharityAuditorsReportOnRevisedAccounts')?.value) {
      this.AuditorForm.get('dateCharityAuditorsReportOnRevisedAccounts')?.setErrors({ AfterOriginalDate: true });
    }
    else {
      this.AuditorForm.get('dateofAudit')?.setErrors(null); // valid date
    }
  }
  RevisedDate_Validate(Event?: any) {
    debugger
    const inputValue = Event?.target?.value;
    const momentDate = moment(inputValue, 'DD/MM/YYYY', true);
    const isValidDate = momentDate.isValid();

    const today = moment(); // current date
    const originalDate = moment(this.AuditorForm.get('dateCharityAuditorsReportOnRevisedAccounts')?.value);
    const dateofAudit = moment(this.AuditorForm.get('dateofAudit')?.value);
    if (!isValidDate) {
      this.AuditorForm.get('dateCharityAuditorsReportOnRevisedAccounts')?.setErrors({ InvalidDate: true });
    }
    else if (momentDate.isAfter(today, 'day')) {
      this.AuditorForm.get('dateCharityAuditorsReportOnRevisedAccounts')?.setErrors({ IsAfterToday: true });
    }
    else if (momentDate.isBefore(dateofAudit, 'day')) {
      this.AuditorForm.get('dateCharityAuditorsReportOnRevisedAccounts')?.setErrors({ AfterOriginalDate: true });
    }
    else {
      this.AuditorForm.get('dateCharityAuditorsReportOnRevisedAccounts')?.setErrors(null); // valid date
    }
  }
  AdvisorsIDs: any = [];
  AdId: any = [];
  Drpodownvalidate(event: MatSelectChange, type?: any) {
    debugger
    const selectedTrusteeId = event.value;
    this.AdvisorsIDs = this.AuditorForm.get('approvedbyAuditor')?.getRawValue();
    if (this.AdvisorsIDs)
      this.AdId = this.AdvisorsIDs;
    var selectedTrustee: any
    if ((selectedTrusteeId && type == 'selected')) {
      this.AuditorForm.get('approvedbyAuditor')?.setErrors(null)
      //selectedTrustee = this.trusteesList.find((t: any) => t.trustee_Id === selectedTrusteeId);
      //this.AuditorForm.patchValue({
      //  trusteeName: selectedTrustee?.name
      //});
    } else {
      if (this.AuditorForm.get('approvedbyAuditor')?.getRawValue() == 0 || this.AuditorForm.get('approvedbyAuditor')?.getRawValue() == null) {
        this.AuditorForm.get('approvedbyAuditor')?.setErrors({ required: true })
      }
    }
  }
  isdirty: boolean = false
  dirty() {

    this.isdirty = true
    this.datashare.setisdirty(true)
  }
  CanDeactivate(): any {
    debugger
    const hasChanges = this.AuditorForm?.dirty || this.hasUnsavedNoteChanges();
    if (this.isdirty) {
      return Swal.fire({
        html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Leave the page?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Are you sure you want to leave this page. <br> Data entered will not be saved.</p>',
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Leave",
        showCancelButton: true,
        cancelButtonText: "Stay",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {

          this.isdirty = false;
          this.datashare.setisdirty(false)
          return true
        } else {
          localStorage.setItem("currentCharityIDFromSwitch", "");
          return false
        }
      })
    }
    else if (hasChanges) {
      return Swal.fire({
        html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Leave the page?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Are you sure you want to leave this page. <br> Data entered will not be saved.</p>',
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Leave",
        showCancelButton: true,
        cancelButtonText: "Stay",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {

          this.isdirty = false;
          this.datashare.setisdirty(false)
          return true
        } else {
          localStorage.setItem("currentCharityIDFromSwitch", "");
          return false
        }
      })
    } else {
      return true
    }
  }
  preventTyping(event: KeyboardEvent, controlName: any): void {
    const control = this.AuditorForm.get(controlName);
    if (!control) {
      return;
    }
    const div = document.createElement('div');
    div.innerHTML = control.value || '';
    const text = div.textContent || '';
    const allowedKeys = ['Backspace',
      'Delete',
      'ArrowLeft',
      'ArrowRight',
      'ArrowUp',
      'ArrowDown',
      'Tab',
      'Home',
      'End'
    ];
    if (text.length >= 2500 && !allowedKeys.includes(event.key) && !event.ctrlKey) {
      event.preventDefault();
      event.stopPropagation();
    }
  }  createAuditor() {

    this.AuditorForm = new FormGroup({
      auditorsReportId: new FormControl(null),
      opinion: new FormControl(this.account_Type == 'Amended' ? this.defaultStatements['unqualifiedrevisedstatement'] : this.defaultStatements['opinion']),
      opiniontype: new FormControl(this.ischecked),
      basisofOpinion: new FormControl(this.defaultStatements['basisofOpinion']),
      conclusions: new FormControl(this.defaultStatements['conclusions'], [
        Validators.required,
        htmlMaxLength(2500)
      ]),
      otherInformation: new FormControl(this.defaultStatements['otherInformation'], [
        Validators.required,
        htmlMaxLength(2500)
      ]),
      othermattersprescribed: new FormControl(this.defaultStatements['othermattersprescribed'], [
        Validators.required,
        htmlMaxLength(2500)
      ]),
      reportbyexception: new FormControl(this.defaultStatements['reportbyexception'], [
        Validators.required,
        htmlMaxLength(2500)
      ]),
      responsibilitiesoftrustees: new FormControl(this.defaultStatements['responsibilitiesoftrustees'], [
        Validators.required,
        htmlMaxLength(2500)
      ]),
      auditorresponsibilities: new FormControl(this.defaultStatements['auditorresponsibilities'], [
        Validators.required,
        htmlMaxLength(2500)
      ]),
      useofthisreport: new FormControl(this.defaultStatements['useofthisreport'], [
        Validators.required,
        htmlMaxLength(2500)
      ]),
      //opinionCharityAuditorsOnRevisedAccounts: new FormControl(""),
      //opinionOnFailureOriginalAccounts: new FormControl(""),
      //isDirectorstrusteesReportConsistent: new FormControl(false),
      dateCharityAuditorsReportOnRevisedAccounts: new FormControl(null),
      approvedbyAuditor: new FormControl(null, [Validators.required]),
      dateofAudit: new FormControl(null, [Validators.required]),
      individual_Description: new FormControl(null, htmlMaxLength(2500)),
      accountingBody: new FormControl('Other/None'),
      savetype1: new FormControl(null),
      savetype2: new FormControl(null),
      savetype3: new FormControl(null),
      savetype4: new FormControl(null),
      savetype5: new FormControl(null),
      savetype6: new FormControl(null),
      savetype7: new FormControl(null),
      savetype8: new FormControl(null),
      savetype9: new FormControl(null),
      savetype10: new FormControl(null),
      accountType: new FormControl((localStorage.getItem("account_Type") ? localStorage.getItem("account_Type")! : '')),
      CharityID: new FormControl((localStorage.getItem("charityId") ? +localStorage.getItem("charityId")! : 0)),
      FinancialPeriodsID: new FormControl(localStorage.getItem("currentPeriod") ? +localStorage.getItem("currentPeriod")! : 0),
      CreatedDate: new FormControl(null),
      Createdby: new FormControl(null),
      Modifiedby: new FormControl(null),
      ModifiedDate: new FormControl(null),
      CentralUserId: new FormControl((localStorage.getItem("CentralUserId") ? +localStorage.getItem("CentralUserId")! : 0)),
      UserId: new FormControl(localStorage.getItem("userID") ? +localStorage.getItem("CurrentuserID")! : 0)

    })
  }
  Back() {

    this.router.navigate(['/trusteeannualreport'])
  }

  backToCharityOverView() {

    localStorage.setItem('isFromBasicInfo', 'true')
    this.router.navigate(['/charity']);

  }
  noteFields = [
    'opinion',
    'basisofOpinion',
    'conclusions',
    'otherInformation',
    'othermattersprescribed',
    'reportbyexception',
    'responsibilitiesoftrustees',
    'auditorresponsibilities',
    'useofthisreport',
    'approvedbyAuditor',
    'dateofAudit',
    'dateCharityAuditorsReportOnRevisedAccounts',
    'individual_Description'
  ];
  //hasUnsavedNoteChanges(): boolean {
  //  return this.noteFields.some(field => this.AuditorForm.get(field)?.dirty);
  //}
  hasUnsavedNoteChanges(): boolean {
    let hasChanges = false;

    this.noteFields.forEach(field => {
      const control = this.AuditorForm.get(field);
      if (control?.dirty) {

        hasChanges = true;
      } else {

      }
    });

    return hasChanges;
  }
  onEditorChange(controlName: string): void {
    const control = this.AuditorForm.get(controlName);
    if (!control) return;

    const html = control.value || '';
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    const plainText = tempDiv.textContent?.trim() || '';

    if (plainText.length === 0) {
      control.setErrors({ required: true });
      this.editorHasError = true
    } else {
      control.setErrors(null);
      this.editorHasError = false;
    }
  }

  UnlockandAmend() {
    debugger
    var fid: any = localStorage.getItem('currentPeriod') ? localStorage.getItem('currentPeriod') : 0
    if (this.UserRoleAccess.m1Amend) {
      Swal.fire({
        html: `<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Are you sure?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black" style="line-height:22px; padding-right: 30px !important;"> Unlocking the accounting period will allow you to amend the filed accounts and correct any errors. After making any changes, the accounts must be submitted again as an Amended filing. Do you want to unlock and amend the accounting period?</p>`,
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Yes",
        showCancelButton: true,
        cancelButtonText: "No",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this._UsermanagementService.UnfreezeAP(+fid).subscribe((data: any) => {
            debugger
            this.sharedService.setFinalStatus('InCompleted');
            localStorage.setItem('apFinalised', 'InCompleted');
            localStorage.setItem('NewAmendCycle', 'true');
            this.Getbasicinformation();
          })
          //this.save("FinaliseandClose");
        }
        else { }
      })
    }
    else {
      Swal.fire({
        html: '<p class= "f-s-14 p-0 m-y-5 f-w-400 text-black" style="line-height:22px"><b>Access Denied</b> <br/> You do not have the required permissions to perform this action</p>',
        iconHtml: '<span class="fa fa-warning"></span>',
        confirmButtonText: "OK",
        allowOutsideClick: false
      })
    }
  }
  UnfreezeAP() {
    debugger
    var fid: any = localStorage.getItem('currentPeriod') ? localStorage.getItem('currentPeriod') : 0
    if (this.UserRoleAccess.m1Submit) {
      Swal.fire({
        html: `<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Are you sure?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black" style="line-height:22px; padding-right: 30px !important;"> Do you want to unlock the Accounting Period? </p>`,
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Yes",
        showCancelButton: true,
        cancelButtonText: "No",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this._UsermanagementService.UnfreezeAP(+fid).subscribe((data: any) => {
            debugger
            const message = "Accounting Period unlocked successfully";
            this.msgService.showToastMessage('success', message)
            this.sharedService.setFinalStatus('InCompleted');
            localStorage.setItem('apFinalised', 'InCompleted')

          })
        }
      })
    } else {
      Swal.fire({
        html: '<p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> <b>Access Denied</b> <br/> You do not have the required permissions to perform this action</p>',
        iconHtml: '<span class="fa fa-warning"></span>',
        confirmButtonText: "OK",
        allowOutsideClick: false
      })
    }
  }
  gotoSubmissions() {
    var fid: any = localStorage.getItem('currentPeriod') ? localStorage.getItem('currentPeriod') : 0
    if (this.UserRoleAccess.m1Submit) {
      this._UsermanagementService.GoToSubmissions()
    } else {
      Swal.fire({
        html: '<p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> <b>Access Denied</b> <br/> You do not have the required permissions to perform this action</p>',
        iconHtml: '<span class="fa fa-warning"></span>',
        confirmButtonText: "OK",
        allowOutsideClick: false
      })
    }

  }
  modalAddAdvisor(template: any) {
    debugger
    this.CreateProfessionalAdvisorsCommonForm();
    this.ProfessionalAdvisorsCommonForm.markAllAsTouched();
    const is2026 = !this.beforeYear;
    this.ProfessionalAdvisorsCommonForm.patchValue({
      professionalAdvisors_Type: 'Auditor',
      advisor_audited_Type: is2026
        ? 'Senior Statutory Charity Auditor'
        : 'Individual Charity Auditor'
    });
    if (!this.beforeYear) {
      this.ProfessionalAdvisorsCommonForm.controls['advisor_audited_Type'].disable()
    }
    this.ProfessionalAdvisorsCommonForm.controls['professionalAdvisors_Type'].disable()

    let dialogRef = this.dialog.open(template, {
      /* width: '40%', maxWidth: '100%', maxHeight: 'auto', height: 'auto', disableClose: true*/
      //width: '40%', maxWidth: '100%', maxHeight: 'auto', height: '88vh', disableClose: true,
      width: '40%', maxWidth: '100%', maxHeight: 'auto', height: 'auto', disableClose: true, panelClass: 'custom-dialog-container'
    });
  }
  CreateProfessionalAdvisorsCommonForm() {
    this.ProfessionalAdvisorsCommonForm = new FormGroup({
      professionalAdvisors_Type: new FormControl(null),
      professionalAdvisors_Name: new FormControl(null),
      professionalAdvisors_FirmName: new FormControl(null),
      professionalAdvisors_Address_Line_1: new FormControl(null),
      professionalAdvisors_Address_Line_2: new FormControl(null),
      professionalAdvisors_Address_Line_3: new FormControl(null),
      professionalAdvisors_City: new FormControl(null),
      professionalAdvisors_County: new FormControl(null),
      professionalAdvisors_Country: new FormControl(null),
      professionalAdvisors_Postcode: new FormControl(null),
      advisorsId: new FormControl(null),
      advisor_audited_Type: new FormControl('Individual Charity Auditor'),
      isPrimary: new FormControl(false)
    })
    this.addAdvisorbtn = true;
    this.updateAdvisorbtn = false;
  }
  AddAdvisor() {
    debugger
    this.edithead = false;
    if (!this.ProfessionalAdvisorsCommonForm.get('professionalAdvisors_Type')?.value) {
      this.ProfessionalAdvisorsCommonForm.get('professionalAdvisors_Type')?.setErrors({ required: true });
      this.ProfessionalAdvisorsCommonForm.get('professionalAdvisors_Type')?.markAsTouched();
    }
    if (!this.ProfessionalAdvisorsCommonForm.get('professionalAdvisors_Name')?.value) {
      this.ProfessionalAdvisorsCommonForm.get('professionalAdvisors_Name')?.setErrors({ required: true });
    }
    if (this.ProfessionalAdvisorsCommonForm.get('professionalAdvisors_Country')?.value &&
      !this.ProfessionalAdvisorsCommonForm.get('professionalAdvisors_Postcode')?.value) {
      this.ProfessionalAdvisorsCommonForm.get('professionalAdvisors_Postcode')?.setErrors({ required: true });
    }
    if (!this.ProfessionalAdvisorsCommonForm.get('professionalAdvisors_FirmName')?.value) {
      this.ProfessionalAdvisorsCommonForm.get('professionalAdvisors_FirmName')?.setErrors({ required: true });
    }
    //if (this.SaveAdviserRecord.length)
    //this.ProfessionalAdvisorsCommonForm.get('advisorsId')?.setValue(this.AdvisorsID ? this.AdvisorsID:0);

    if (this.ProfessionalAdvisorsCommonForm.valid) {
      const charityId = +(localStorage.getItem('charityId') ?? '0');
      const form = this.ProfessionalAdvisorsCommonForm.getRawValue();

      const payload: any = {
        ...form, charityId,
        // Map to the name the API expects:
        Advisor_Audited_Type:
          form.professionalAdvisors_Type === 'Auditor' ? (form.advisor_audited_Type ?? null) : null
      };


      delete payload.advisor_audited_Type;

      console.log('Advisor payload ->', payload);
      this.ShowSpinner = true;
      this.Charities_Service.saveAdvisor(payload).subscribe((data: any) => {
        this.ShowSpinner = false;
        this.msgService.showToastMessage('success', data.mesage);
        this.dialog.closeAll();
        this.Charity_Service.getProfessionalAdvisorDetails(charityId).subscribe((res: any) => {
          this.ProfessionalAdvisorsDetails = res.entity;
          this.ShowSpinner = false;
          this.dialog.closeAll();
          this.filteredAdvisors = this.ProfessionalAdvisorsDetails.filter((advisor: any) => advisor.professionalAdvisors_Type === "Auditor");
          if (this.filteredAdvisors.length > 0) {
            const auditorname = this.filteredAdvisors[this.filteredAdvisors.length - 1];
            this.AuditorForm.get('approvedbyAuditor')?.setValue(auditorname.advisorsId);
          }
        })
        this.GetProfessionalAdvisorsDetails();
      });


    }
  }
  closeAdvisor() {
    debugger
    this.edithead = false;
    if (this.ProfessionalAdvisorsCommonForm.dirty) {
      return Swal.fire({
        html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Leave the page?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px">Are you sure you want to leave the page.<br\>Data entered will not be saved.</p>',
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Leave",
        showCancelButton: true,
        cancelButtonText: "Stay",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          // this.adviserTypes = this.adviserTypes.filter(item => item !== (this.ProfessionalAdvisorsCommonForm.get('professionalAdvisors_Type')?.value));
          this.CreateProfessionalAdvisorsCommonForm();
          this.dialog.closeAll()

          if (this.AdId) {
            this.AuditorForm.get('approvedbyAuditor')?.setValue(this.AdId);
          } else {
            if (this.selectedAuditorId)
              this.AuditorForm.get('approvedbyAuditor')?.setValue(this.selectedAuditorId);

          }
          return
        }
        else {
          return
        }
      })
    }
    else {
      //this.adviserTypes = this.adviserTypes.filter(item => item !== (this.ProfessionalAdvisorsCommonForm.get('professionalAdvisors_Type')?.value));
      this.CreateProfessionalAdvisorsCommonForm();
      this.dialog.closeAll()
      if (this.AdId) {
        this.AuditorForm.get('approvedbyAuditor')?.setValue(this.AdId);
      } else {
        if (this.selectedAuditorId)
          this.AuditorForm.get('approvedbyAuditor')?.setValue(this.selectedAuditorId);

      }

      //  this.GetProfessionalAdvisorsDetails();
    }
    return
  }

  onselectAuditorType(event: any) {
    debugger
    let date = this.BasicInformation[0]?.current_AP_End_Date;
    let formatteddate = date.split("T")[0];
    if (formatteddate >= '2026-04-01') {
      if (event.value == 'Senior Statutory Charity Auditor') {
        this.ProfessionalAdvisorsCommonForm.get('professionalAdvisors_FirmName')?.setValidators([Validators.required]);
      }
      else {
        this.ProfessionalAdvisorsCommonForm.get('professionalAdvisors_FirmName')?.clearValidators();
      }
    }
    this.ProfessionalAdvisorsCommonForm.get('professionalAdvisors_FirmName')?.updateValueAndValidity();
  }

  //const dateString = this.BasicInformation[0].current_AP_End_Date;
  //const year = dateString ? new Date(dateString).getFullYear() : null;
  //if (year && year >= 2026) 
  //  { 
  //  if (event.value == 'Senior Statutory Charity Auditor') {
  //    this.ProfessionalAdvisorsCommonForm.get('professionalAdvisors_FirmName')?.setValidators([Validators.required]);
  //  }
  //  else {
  //    this.ProfessionalAdvisorsCommonForm.get('professionalAdvisors_FirmName')?.clearValidators();
  //  }
  //}

  validatepostcode() {
    debugger
    if (this.ProfessionalAdvisorsCommonForm.get('professionalAdvisors_Country')?.value == 'United Kingdom' && this.ProfessionalAdvisorsCommonForm.get('professionalAdvisors_Postcode')?.value) {
      if (!new RegExp(/^((([A-Z][0-9][0-9]?)|(([A-Z][A-HJ-Y][0-9][0-9]?)|(([A-Z][0-9][A-Z])|([A-Z][A-HJ-Y][0-9]?[A-Z])))) [0-9][A-Z]{2})$/).test(this.ProfessionalAdvisorsCommonForm.get('professionalAdvisors_Postcode')?.value)) {
        this.ProfessionalAdvisorsCommonForm.get('professionalAdvisors_Postcode')?.setErrors({ invalid: true })
      }
    }
    else {
      if (this.ProfessionalAdvisorsCommonForm.get('professionalAdvisors_Country')?.value && !this.ProfessionalAdvisorsCommonForm.get('professionalAdvisors_Postcode')?.value) {
        //this.ProfessionalAdvisorsForm.get('auditors_Details_postcode')?.setErrors({ required: true })
      }
      else {
        this.ProfessionalAdvisorsCommonForm.get('professionalAdvisors_Postcode')?.setErrors(null)
      }

    }
  }
  private handleApprovedByAuditorState(): void {
    debugger
    const control = this.AuditorForm.get('approvedbyAuditor');

    if (!control) return;

    const value = control.value;

    if (value !== null && value !== undefined && value !== '') {
      control.disable({ emitEvent: false });
    } else {
      control.enable({ emitEvent: false });
    }
  }

  onPrimaryChange(event: any) {
    debugger
    if (event.checked) {
      this.ProfessionalAdvisorsCommonForm.get('isPrimary')?.setValue(true);
    }
    else {
      this.ProfessionalAdvisorsCommonForm.get('isPrimary')?.setValue(false);
    }
  }
  enablePlainTextPaste(): void {
    this.pasteHandler = (event: ClipboardEvent) => {
      const target = event.target as HTMLElement;
      if (!target.closest('.ProseMirror')) {
        return;
      }
      event.preventDefault();
      const text = event.clipboardData?.getData('text/plain') || '';
      document.execCommand('insertText', false, text);
    };
    document.addEventListener('paste', this.pasteHandler, true);
  }

  onChangeAuditor(event: MatSelectChange): void {
    debugger
    this.AuditorForm.get('individual_Description')?.reset();
    this.updateIndividualDescriptionValidation();
    this.dirty();
  }
}


